{
  "staff_lookup_help": "Συμπληρώστε ολόκληρο email ή κινητό (+30 ή +357) για έλεγχο υπάρχοντος λογαριασμού. Δεν γίνεται αναζήτηση με όνομα ή μερικά στοιχεία.",
  "staff_lookup_loading": "Έλεγχος λογαριασμού...",
  "staff_lookup_error": "Ο έλεγχος λογαριασμού απέτυχε. Αλλάξτε το στοιχείο επικοινωνίας και δοκιμάστε ξανά.",
  "staff_lookup_conflict": "Τα στοιχεία δεν αντιστοιχούν σε έναν λογαριασμό. Ελέγξτε τα ή επικοινωνήστε με την υποστήριξη.",
  "staff_lookup_not_found": "Δεν βρέθηκε λογαριασμός με αυτά τα στοιχεία. Δημιουργήστε νέο λογαριασμό προσωπικού παρακάτω.",
  "staff_lookup_existing": "Υπάρχων λογαριασμός",
  "staff_lookup_change": "Αλλαγή λογαριασμού",
  "staff_lookup_select": "Χρήση αυτού του λογαριασμού",
  "staff_lookup_assign": "Προσθήκη πρόσβασης",
  "STAFF_ACCOUNT_EXISTS": "Υπάρχει πλέον λογαριασμός με αυτά τα στοιχεία. Αναζητήστε τον ξανά και επιλέξτε τον.",
  "empty_staff_title": "Δεν υπάρχει προσωπικό ακόμα",
  "empty_staff_description": "Πρόσθεσε τους προπονητές και τους διαχειριστές της ακαδημίας και όρισε σε ποιες ομάδες έχουν πρόσβαση. Θα συνδεθούν με το email που θα συμπληρώσεις και θα βλέπουν τις ομάδες τους στην εφαρμογή.",
  "empty_files_title": "Δεν υπάρχουν αρχεία ακόμα",
  "empty_files_period_title": "Δεν υπάρχουν αρχεία σε αυτό το διάστημα",
  "empty_announcements_period_title": "Δεν υπάρχουν ανακοινώσεις σε αυτό το διάστημα",
  "empty_period_description": "Δοκίμασε να αλλάξεις το διάστημα ημερομηνιών για να δεις τις υπάρχουσες καταχωρήσεις.",
  "empty_files_description": "Στείλε έγγραφα, οδηγίες ή ό,τι χρειάζονται τα μέλη σε μία ή περισσότερες ομάδες ή σε συγκεκριμένους παίκτες. Τα αρχεία εμφανίζονται στην ενότητα αρχείων μέσα στην εφαρμογή.",
  "empty_files_filtered_title": "Δεν βρέθηκαν αρχεία με αυτά τα φίλτρα",
  "empty_files_filtered_description": "Δοκίμασε να αλλάξεις ή να αφαιρέσεις τα φίλτρα και την αναζήτηση.",
  "empty_forms_title": "Δεν υπάρχουν φόρμες ακόμα",
  "empty_forms_description": "Δημιούργησε μια φόρμα για να συγκεντρώσεις στοιχεία από γονείς και παίκτες ή μια αξιολόγηση που θα συμπληρώνει ο προπονητής. Μετά την ανάθεσή της στους παίκτες, μπορείς να παρακολουθείς ποιοι την έχουν συμπληρώσει.",
  "empty_products_title": "Δεν υπάρχουν προϊόντα ακόμα",
  "empty_products_description": "Δημιούργησε ένα προϊόν, όπως μια συνδρομή ή ρουχισμό, και μετά χρέωσέ το στους παίκτες που αφορά, εφάπαξ ή σε δόσεις. Οι γονείς βλέπουν την πληρωμή στην εφαρμογή και εσύ παρακολουθείς τα έσοδα της ακαδημίας.",
  "empty_products_filtered_title": "Δεν βρέθηκαν προϊόντα με αυτά τα φίλτρα",
  "empty_club_title": "Ξεκίνα δημιουργώντας την πρώτη σου ομάδα",
  "empty_club_description": "Οι ομάδες είναι η βάση της ακαδημίας σου. Όταν δημιουργήσεις μία, θα πάρεις έναν κωδικό που μοιράζεις σε γονείς και παίκτες για να συνδεθούν από την εφαρμογή.",
  "teams_load_failed": "Δεν ήταν δυνατή η φόρτωση των ομάδων. Δοκίμασε ξανά.",
  "empty_calendar_title": "Δεν υπάρχουν δραστηριότητες αυτή την ημέρα",
  "activities_load_failed": "Δεν ήταν δυνατή η φόρτωση των δραστηριοτήτων. Δοκίμασε ξανά.",
  "empty_calendar_description": "Δημιούργησε έναν αγώνα, μια προπόνηση ή μια εκδήλωση και τα μέλη της ομάδας θα ειδοποιηθούν αμέσως. Αν η προπόνηση γίνεται κάθε εβδομάδα, ενεργοποίησε την Επανάληψη και δεν χρειάζεται να την περνάς ξανά.",
  "empty_players_title": "Δεν υπάρχουν παίκτες ακόμα",
  "empty_players_description": "Οι παίκτες και οι γονείς συνδέονται μόνοι τους με τον κωδικό της ομάδας από την εφαρμογή. Μπορείς επίσης να δημιουργήσεις εσύ το προφίλ ενός παίκτη.",
  "empty_announcements_title": "Δεν υπάρχουν ανακοινώσεις ακόμα",
  "empty_announcements_description": "Στείλε μια ανακοίνωση σε μία ή περισσότερες ομάδες, ή σε όλη την ακαδημία, και θα δεις πόσα μέλη την είδαν. Μια καλή αρχή είναι μια ανακοίνωση καλωσορίσματος.",
  "empty_players_filtered_title": "Δεν βρέθηκαν παίκτες",
  "empty_players_filtered_description": "Δοκίμασε να αλλάξεις ή να αφαιρέσεις τα φίλτρα και την αναζήτηση.",
  "empty_calendar_filtered_title": "Δεν βρέθηκαν δραστηριότητες με αυτά τα φίλτρα",
  "empty_announcements_filtered_title": "Δεν βρέθηκαν ανακοινώσεις με αυτά τα φίλτρα",
  "empty_filtered_description": "Δοκίμασε να αλλάξεις ή να αφαιρέσεις τα φίλτρα.",
  "empty_clear_filters": "Καθαρισμός φίλτρων",
  "page_help_need_help": "Χρειάζεσαι βοήθεια;",
  "page_help_settings_title": "Βοήθεια ανά ενότητα",
  "page_help_settings_description": "Ορίστε ποια συλλογή του Κέντρου βοήθειας ανοίγει κάθε ενότητα του Manager. Αποθηκεύστε εδώ τους συνδέσμους και ενημερώστε τις οδηγίες στο Intercom.",
  "page_help_language_note": "Ο σύνδεσμος βοήθειας εμφανίζεται όταν η ενότητα είναι ενεργή και υπάρχει σύνδεσμος για τη γλώσσα του χρήστη. Για ελληνικές οδηγίες και σε χρήστες με αγγλικό περιβάλλον, βάλτε τον ίδιο ελληνικό σύνδεσμο και στα δύο πεδία.",
  "page_help_enabled": "Εμφάνιση βοήθειας",
  "page_help_greek_url": "Σύνδεσμος ελληνικής συλλογής",
  "page_help_english_url": "Σύνδεσμος αγγλικής συλλογής",
  "page_help_preview": "Προεπισκόπηση",
  "page_help_url_hint": "Δημοσιευμένη συλλογή στο help.playerdex.app ή intercom.help/playerdex. Αφήστε κενό για απόκρυψη της βοήθειας σε αυτή τη γλώσσα.",
  "page_help_invalid_url": "Βάλτε σύνδεσμο HTTPS συλλογής του Κέντρου βοήθειας PlayerDex, χωρίς θύρα, παραμέτρους ή απόσπασμα.",
  "page_help_url_required": "Προσθέστε τουλάχιστον έναν σύνδεσμο συλλογής πριν ενεργοποιήσετε τη βοήθεια.",
  "page_help_reload": "Φόρτωση τελευταίων",
  "page_help_reload_note": "Η φόρτωση τελευταίων αντικαθιστά τις μη αποθηκευμένες αλλαγές σας με τους τρέχοντες αποθηκευμένους συνδέσμους.",
  "page_help_loading": "Φόρτωση συνδέσμων βοήθειας",
  "page_help_saving": "Αποθήκευση συνδέσμων βοήθειας",
  "page_help_saved": "Οι σύνδεσμοι αποθηκεύτηκαν. Οι αλλαγές εμφανίζονται στην επόμενη επίσκεψη ή ανανέωση της σελίδας.",
  "page_help_load_error": "Δεν ήταν δυνατή η φόρτωση των συνδέσμων. Δοκιμάστε «Φόρτωση τελευταίων».",
  "page_help_save_error": "Δεν ήταν δυνατή η αποθήκευση. Οι αλλαγές σας παραμένουν εδώ· δοκιμάστε ξανά.",
  "page_help_conflict": "Άλλος διαχειριστής αποθήκευσε αλλαγές. Το πρόχειρό σας διατηρήθηκε. Αντιγράψτε τις αλλαγές που θέλετε να κρατήσετε και φορτώστε τους τελευταίους συνδέσμους πριν αποθηκεύσετε ξανά.",
  "page_help_forbidden": "Μόνο οι super admins μπορούν να διαχειρίζονται τη βοήθεια. Τερματίστε την προσωρινή σύνδεση ως άλλος χρήστης πριν ανοίξετε τις ρυθμίσεις.",
  "help_section_announcements": "Ανακοινώσεις",
  "help_section_schedule": "Πρόγραμμα",
  "help_section_teams": "Ομάδες",
  "help_section_players": "Παίκτες",
  "help_section_staff": "Προσωπικό",
  "help_section_invitations": "Προσκλήσεις",
  "help_section_files": "Αρχεία",
  "help_section_forms": "Φόρμες",
  "help_section_member_subscriptions": "Συνδρομές μελών / προϊόντα",
  "help_section_member_payments": "Πληρωμές μελών / έσοδα",
  "help_section_club_billing": "Συνδρομή ακαδημίας / χρέωση",
  "help_section_account_settings": "Ρυθμίσεις λογαριασμού",
  "billing_details_managed_in_stripe": "Τα στοιχεία τιμολόγησής σας διαχειρίζονται στο Stripe. Ανοίξτε τη Χρέωση για να συνεχίσετε.",
  "mobile_sign_in_title": "Συνεχίστε στην εφαρμογή PlayerDex",
  "mobile_sign_in_description": "Αυτός ο σύνδεσμος σύνδεσης προορίζεται για την εφαρμογή PlayerDex. Συνεχίστε στο κινητό από το οποίο τον ζητήσατε.",
  "mobile_sign_in_open": "Άνοιγμα στο PlayerDex",
  "mobile_sign_in_open_help": "Αν η εφαρμογή δεν ανοίξει, επιστρέψτε στο email στο ίδιο κινητό και δοκιμάστε ξανά. Μπορείτε επίσης να ανοίξετε το PlayerDex και να ζητήσετε νέο σύνδεσμο σύνδεσης.",
  "mobile_sign_in_desktop": "Ανοίξτε αυτό το email στο κινητό από το οποίο ζητήσατε τον σύνδεσμο σύνδεσης.",
  "mobile_sign_in_invalid": "Ο σύνδεσμος δεν είναι πλήρης. Ανοίξτε το PlayerDex και ζητήστε νέο σύνδεσμο σύνδεσης.",
  "mobile_sign_in_install_help": "Χρειάζεστε την εφαρμογή; Εγκαταστήστε ή ενημερώστε το PlayerDex και ζητήστε νέο σύνδεσμο σύνδεσης από την εφαρμογή.",
  "mobile_sign_in_manager_help": "Για να χρησιμοποιήσετε το PlayerDex Manager από τον browser, μεταβείτε στη σελίδα σύνδεσης και συνδεθείτε με κωδικό email.",
  "mobile_sign_in_manager": "Σύνδεση στο Manager",
  "form_date_range_invalid": "Η ημερομηνία λήξης πρέπει να είναι ίδια ή μεταγενέστερη της ημερομηνίας έναρξης.",
  "order_invalid_month": "Εισάγετε έγκυρο μήνα σε μορφή MM/YYYY ή επιλέξτε από το ημερολόγιο.",
  "order_month_out_of_range": "Επιλέξτε μήνα μεταξύ 01/2020 και 01/2099.",
  "order_end_month_before_start": "Ο μήνας λήξης πρέπει να είναι ίδιος ή μεταγενέστερος του μήνα έναρξης.",
  "order_invalid_payment_amounts": "Τα ποσά πληρωμής πρέπει να είναι μη αρνητικά και να μην υπερβαίνουν το σύνολο της παραγγελίας.",
  "order_unable_to_load_club_teams": "Δεν ήταν δυνατή η φόρτωση των ομάδων της ακαδημίας.",
  "impersonation_missing_id": "Ο επιλεγμένος λογαριασμός δεν έχει αναγνωριστικό χρήστη.",
  "impersonation_identity_mismatch": "Ο λογαριασμός που επέστρεψε δεν αντιστοιχεί στον επιλεγμένο χρήστη. Η ενέργεια ακυρώθηκε.",
  "impersonation_no_matches": "Δεν βρέθηκαν χρήστες.",
  "impersonation_no_club": "Ο επιλεγμένος λογαριασμός δεν διαχειρίζεται ακαδημία.",
  "impersonation_choose_account": "Βρέθηκαν πολλοί λογαριασμοί. Επιλέξτε τον σωστό με βάση το αναγνωριστικό και τις ακαδημίες/ομάδες του.",
  "impersonation_select_account": "Επιλογή λογαριασμού",
  "staff_edit": "Επεξεργασία προσωπικού",
  "staff_choose_role": "Το μέλος έχει διαφορετικούς ρόλους ανά ομάδα. Επιλέξτε τον ρόλο που θα ισχύει στις επιλεγμένες ομάδες.",
  "staff_edit_failed": "Οι αλλαγές δεν αποθηκεύτηκαν. Δοκιμάστε ξανά.",
  "staff_updated": "Τα στοιχεία προσωπικού ενημερώθηκαν επιτυχώς.",
  "email_change_send_code": "Αποστολή κωδικού",
  "email_change_verify_title": "Επιβεβαίωση email",
  "email_change_verify_save": "Επιβεβαίωση και αποθήκευση",
  "email_change_edit_address": "Αλλαγή διεύθυνσης",
  "email_change_code_notice": "Θα στείλουμε έναν εξαψήφιο κωδικό στο νέο σας email. Το email θα αποθηκευτεί μόνο αφού πληκτρολογήσετε τον κωδικό εδώ.",
  "email_change_code_failed": "Δεν ήταν δυνατή η αποστολή του κωδικού. Δοκιμάστε ξανά.",
  "email_change_same_address": "Αυτό το email είναι ήδη επιβεβαιωμένο στον λογαριασμό σας.",
  "registration_language": "Γλώσσα",
  "registration_brand_title": "Η ακαδημία σας, οργανωμένη.",
  "registration_brand_description": "Οργανώστε τις ομάδες, τα μέλη και την καθημερινότητα της ακαδημίας σας στο PlayerDex Manager.",
  "registration_brand_details": "Διαχειριστείτε το πρόγραμμα, τις παρουσίες, τα στοιχεία μελών και τις φόρμες της ακαδημίας από ένα σημείο.",
  "registration_welcome": "Καλώς ήρθατε στο PlayerDex",
  "registration_email_description": "Εισαγάγετε το email σας για είσοδο ή δημιουργία ακαδημίας.",
  "registration_check_email": "Ελέγξτε το email σας",
  "registration_link_instructions": "Ανοίξτε τον σύνδεσμο εισόδου που στείλαμε στο:",
  "registration_email_help": "Χρησιμοποιήστε τον σύνδεσμο σε αυτόν τον browser. Αν δεν έφτασε, ελέγξτε τα ανεπιθύμητα. Αν ο σύνδεσμος δεν λειτουργεί πλέον, ζητήστε νέο.",
  "registration_resend": "Αποστολή νέου συνδέσμου",
  "registration_change_email": "Αλλαγή email",
  "registration_continue": "Συνέχεια",
  "registration_or": "ή",
  "registration_email_send_failed": "Δεν ήταν δυνατή η αποστολή email. Ελέγξτε τη σύνδεση και τη διεύθυνσή σας και δοκιμάστε ξανά.",
  "registration_phone_description": "Χρησιμοποιήστε τον αριθμό τηλεφώνου που είναι ήδη καταχωρημένος στον λογαριασμό σας.",
  "registration_sms_send_failed": "Δεν ήταν δυνατή η αποστολή SMS. Ελέγξτε τον αριθμό και τη σύνδεσή σας και δοκιμάστε ξανά.",
  "registration_sms_code_failed": "Δεν ήταν δυνατή η επαλήθευση του κωδικού SMS. Ελέγξτε τον κωδικό ή επιλέξτε είσοδο με email.",
  "registration_send_sms": "Αποστολή SMS",
  "registration_verify_sms": "Επαλήθευση και είσοδος",
  "registration_mobile_app": "Κατεβάστε την εφαρμογή στο κινητό σας αν είστε προπονητής, παίκτης ή γονέας.",
  "registration_session_error": "Δεν ήταν δυνατός ο συγχρονισμός του λογαριασμού σας με το PlayerDex. Ελέγξτε τη σύνδεση και δοκιμάστε ξανά ή αλλάξτε λογαριασμό.",
  "registration_manager_access_required": "Το PlayerDex Manager είναι διαθέσιμο μόνο σε διαχειριστές ακαδημιών και υπερδιαχειριστές. Συνδεθείτε με λογαριασμό διαχειριστή.",
  "registration_retry": "Δοκιμή ξανά",
  "registration_change_account": "Αποσύνδεση / αλλαγή λογαριασμού",
  "email_code_sent_to": "Στείλαμε έναν 6ψήφιο κωδικό στο",
  "email_code_expiry_help": "Ο κωδικός ισχύει για 15 λεπτά.",
  "email_code_label": "6ψήφιος κωδικός επαλήθευσης email",
  "email_code_verify": "Επαλήθευση",
  "email_code_not_received": "Δεν λάβατε τον κωδικό;",
  "email_code_resend_in": "Νέα αποστολή σε",
  "email_code_resend": "Αποστολή νέου κωδικού",
  "email_code_invalid": "Ο κωδικός είναι λανθασμένος. Ελέγξτε το email και δοκιμάστε ξανά.",
  "email_code_expired": "Ο κωδικός έληξε ή έχει ήδη χρησιμοποιηθεί. Ζητήστε νέο κωδικό.",
  "email_code_attempts_exhausted": "Έγιναν πολλές λανθασμένες προσπάθειες. Ζητήστε νέο κωδικό για να συνεχίσετε.",
  "email_code_rate_limited": "Περιμένετε λίγο πριν ζητήσετε ή ελέγξετε άλλον κωδικό.",
  "email_code_unavailable": "Δεν ήταν δυνατή η επαλήθευση email. Δοκιμάστε ξανά.",
  "registration_create_club": "Δημιουργήστε την ακαδημία σας",
  "registration_create_profile": "Δημιουργήστε το προφίλ σας",
  "registration_complete_setup": "Ολοκλήρωση εγγραφής",
  "registration_upload_photo": "Μεταφόρτωση φωτογραφίας",
  "registration_upload_photo_action": "Μεταφόρτωση ή αλλαγή φωτογραφίας προφίλ",
  "registration_photo_preview": "Η φωτογραφία προφίλ σας",
  "registration_photo_hint": "Προαιρετικά. JPEG, PNG ή WebP, έως 5 MiB.",
  "registration_undo_photo": "Αναίρεση επιλογής φωτογραφίας",
  "registration_club_step_description": "Ξεκινήστε με τα βασικά στοιχεία της ακαδημίας. Μπορείτε να προσθέσετε περισσότερα αργότερα.",
  "registration_admin_step_description": "Συμπληρώστε τα στοιχεία διαχειριστή για να ολοκληρώσετε τη δημιουργία της ακαδημίας.",
  "registration_country_greece": "Ελλάδα",
  "registration_color": "Χρώμα",
  "registration_country_cyprus": "Κύπρος",
  "registration_back": "Πίσω στα στοιχεία ακαδημίας",
  "registration_sign_out": "Αποσύνδεση",
  "registration_setup_description": "Συμπληρώστε τα στοιχεία διαχειριστή και τα βασικά στοιχεία της ακαδημίας. Μπορείτε να προσθέσετε περισσότερα στις ρυθμίσεις αργότερα.",
  "registration_verified_email": "Επαληθευμένο email",
  "registration_first_name": "Όνομα",
  "registration_last_name": "Επώνυμο",
  "registration_club_name": "Όνομα ακαδημίας",
  "registration_logo_optional": "Λογότυπο ακαδημίας (προαιρετικό)",
  "registration_logo_preview": "Προεπισκόπηση λογοτύπου ακαδημίας",
  "registration_upload_logo": "Μεταφόρτωση λογοτύπου",
  "registration_upload_logo_action": "Μεταφόρτωση ή αλλαγή λογοτύπου ακαδημίας",
  "registration_remove_logo": "Αφαίρεση λογοτύπου",
  "registration_logo_hint": "PNG, JPEG ή WebP, έως 5 MB. Μπορείτε να προσθέσετε λογότυπο αργότερα.",
  "registration_hex_color": "Χρώμα (#RRGGBB)",
  "registration_agree": "Αποδέχομαι τους",
  "registration_terms": "Όρους Χρήσης",
  "registration_and": "και την",
  "registration_privacy": "Πολιτική Απορρήτου",
  "registration_required_name": "Εισαγάγετε όνομα με 1–100 χαρακτήρες.",
  "registration_choose_country": "Επιλέξτε χώρα.",
  "registration_choose_sport": "Επιλέξτε άθλημα.",
  "registration_invalid_color": "Επιλέξτε χρώμα ακαδημίας.",
  "registration_accept_terms": "Αποδεχτείτε τους Όρους Χρήσης και την Πολιτική Απορρήτου για να συνεχίσετε.",
  "registration_invalid_logo": "Επιλέξτε εικόνα PNG, JPEG ή WebP, έως 5 MB.",
  "registration_check_fields": "Ελέγξτε τα επισημασμένα πεδία.",
  "registration_club_created": "Η ακαδημία σας δημιουργήθηκε. Ολοκληρώστε την αποθήκευση της εμφάνισής της παρακάτω.",
  "registration_finish_setup": "Ολοκλήρωση ρύθμισης",
  "registration_check_again": "Νέος έλεγχος δημιουργίας ακαδημίας",
  "registration_creation_uncertain": "Δεν μπορέσαμε να επιβεβαιώσουμε αν δημιουργήθηκε η ακαδημία σας. Ελέγξτε ξανά πριν συνεχίσετε. Αν το πρόβλημα επιμένει, επικοινωνήστε με την υποστήριξη PlayerDex. Δεν θα δημιουργηθεί δεύτερη ακαδημία από αυτό το αίτημα.",
  "registration_club_unavailable": "Η ακαδημία δεν είναι πλέον διαθέσιμη στον λογαριασμό σας. Αλλάξτε λογαριασμό ή επικοινωνήστε με την υποστήριξη PlayerDex.",
  "registration_reselect_logo": "Η ακαδημία αποθηκεύτηκε. Επιλέξτε ξανά το αρχείο λογοτύπου για να ολοκληρωθεί η μεταφόρτωση ή αφαιρέστε το για να συνεχίσετε χωρίς λογότυπο.",
  "registration_logo_retry": "Η μεταφόρτωση λογοτύπου δεν ολοκληρώθηκε. Η ακαδημία αποθηκεύτηκε. Δοκιμάστε ξανά ή αφαιρέστε το λογότυπο.",
  "registration_logo_remove_failed": "Δεν ήταν δυνατή η αφαίρεση λογοτύπου. Δοκιμάστε ξανά πριν συνεχίσετε.",
  "registration_save_failed": "Δεν αποθηκεύτηκαν όλα τα στοιχεία. Ελέγξτε τη σύνδεση και δοκιμάστε ξανά. Αν η ακαδημία έχει ήδη δημιουργηθεί, θα χρησιμοποιηθεί η ίδια.",
  "registration_access_changed": "Μια ακαδημία έχει ήδη συνδεθεί με αυτόν τον λογαριασμό. Ανανεώστε τη σελίδα για να συνεχίσετε στην υπάρχουσα ακαδημία.",
  "registration_busy": "Η ρύθμιση εκτελείται ήδη σε άλλη καρτέλα. Περιμένετε να ολοκληρωθεί και ανανεώστε τη σελίδα.",
  "registration_verified_email_required": "Συνδεθείτε με επαληθευμένο email για να δημιουργήσετε την ακαδημία σας.",
  "session_identity_changed": "Ο λογαριασμός σας άλλαξε. Συνδεθείτε ξανά πριν συνεχίσετε.",
  "error": "Σφάλμα",
  "errors": "Σφάλματα",
  "info": "Ενημέρωση",
  "warning": "Προειδοποίηση",
  "success": "Επιτυχία!",
  "an_error_occurred": "Προέκυψε ένα σφάλμα!",
  "error_server_not_responding": "Πρόβλημα σύνδεσης με τον server",
  "login_success": "Η σύνδεση ολοκληρώθηκε με επιτυχία",
  "error_during_login": "Πρόβλημα κατά τη σύνδεση (login). Παρακαλώ προσπαθήστε ξανά.",
  "error_during_logout": "Πρόβλημα κατά την αποσύνδεση (logout). Παρακαλώ προσπαθήστε ξανά.",
  "too_many_attempts_try_later": "Πραγματοποιήθηκαν πολλές προσπάθειες σύνδεσης. Ο χρήστης έχει κλειδωθεί. Παρακαλώ δοκιμάστε ξανά αργότερα.",
  "menu": "Μενού",
  "sidebar_toggle": "Εμφάνιση ή απόκρυψη μενού",
  "table_columns": "Στήλες",
  "show_more": "Περισσότερα",
  "brand_color": "Χρώμα ακαδημίας",
  "black": "μαύρο",
  "red": "κόκκινο",
  "orange": "πορτοκαλί",
  "yellow": "κίτρινο",
  "green": "πράσινο",
  "light_blue": "γαλάζιο",
  "blue": "μπλε",
  "purple": "μωβ",
  "change_language": "Αλλαγή γλώσσας",
  "switch_to_english": "Αλλαγή σε Αγγλικά",
  "switch_to_greek": "Αλλαγή σε Ελληνικά",
  "impersonate_user": "Να κάνουμε impersonate τον χρήστη;",
  "leave_impersonate": "Έξοδος impersonate",
  "checkout_success_message1": "Σας ευχαριστούμε για τη συνδρομή σας! Θα λάβετε email επιβεβαίωσης στο:",
  "checkout_success_message2": ". Για οποιαδήποτε ερώτηση, επικοινωνήστε μαζί μας στο: ",
  "choose_plan": "Διάλεξε το πρόγραμμα που θα κάνει τη διαφορά για την ακαδημία σου",
  "start_now": "Ξεκίνα τώρα!",
  "loading": "Φόρτωση...",
  "not_a_customer_yet": "Δεν είστε ακόμα πελάτης;",
  "welcome_to": "Καλωσήρθες στην",
  "choose_club_modal_title": "Διαχείριση άλλης ακαδημίας;",
  "choose_club_confirmation_msg1": "Έχετε επιλέξει να διαχειριστείτε την ακαδημία",
  "choose_club_confirmation_msg2": "Είστε σίγουροι;",
  "home": "Ανακοινώσεις",
  "home_subtitle": "Στείλε ανακοινώσεις στις ομάδες της ακαδημίας, ενημέρωσε άμεσα τα μέλη και δες ποιοι τις είδαν.",
  "schedule_title": "Ημερολόγιο",
  "schedule_subtitle": "Δημιούργησε και διαχειρίσου τους αγώνες, τις προπονήσεις και τις εκδηλώσεις των ομάδων της ακαδημίας.",
  "seen_by_parent": "Το είδε γονέας",
  "seen": "Το είδαν",
  "not_seen": "Δεν το είδαν",
  "no_post_viewers": "Κανείς δεν έχει δει ακόμη αυτή την ανάρτηση.",
  "reacted": "Αντέδρασαν / Είδαν",
  "not_reacted": "Δεν αντέδρασαν / είδαν",
  "Leagues": "Διοργανώσεις",
  "Academies": "Ακαδημίες",
  "Attendance": "Παρουσιολόγιο",
  "Matches": "Αγώνες",
  "Players": "Παίκτες",
  "Users": "Χρήστες",
  "Payments": "Πληρωμές",
  "no_posts_found": "Δε βρέθηκαν ανακοινώσεις.",
  "newPost": "Δημιουργία",
  "teams": "Ομάδες",
  "type": "Κατηγορία",
  "types": "Κατηγορία",
  "viewAll": "Προβολή όλων",
  "ok": "OK",
  "or": "ή",
  "text_filter": "Ανακοινώσεις",
  "training_filter": "Προπονήσεις",
  "match_filter": "Αγώνες",
  "createAnnouncement": "Νέα ανακοίνωση",
  "addTraining": "Νέα προπόνηση",
  "addMatch": "Νέος αγώνας",
  "continue": "Συνέχεια",
  "new": "Νέα",
  "post": "Ανακοίνωση",
  "attachments": "Συνημμένα",
  "add_attachment": "Προσθήκη συνημμένου",
  "remove_attachment": "Αφαίρεση συνημμένου",
  "activity_attachment_empty": "Τα συνημμένα αρχεία δεν μπορούν να είναι κενά.",
  "activity_attachment_too_large": "Κάθε συνημμένο αρχείο πρέπει να είναι έως 15 MB.",
  "activity_attachment_upload_failed": "Δεν ήταν δυνατή η μεταφόρτωση του συνημμένου. Δοκιμάστε ξανά.",
  "attach_shared_files": "Προσθήκη συνημμένων αρχείων",
  "attach": "Προσθήκη",
  "detach_file": "Αφαίρεση αρχείου",
  "files_attached_successfully": "Τα αρχεία προστέθηκαν επιτυχώς.",
  "please_select_files_to_attach": "Παρακαλώ επιλέξτε αρχεία.",
  "missing_file_url_or_name": "Λείπει το URL ή το όνομα του αρχείου.",
  "versus": "VS",
  "update": "Επεξεργασία",
  "announcement": "Aνακοίνωση",
  "uploadPhoto": "Προσθήκη φωτογραφίας",
  "upload_logo": "Προσθήκη λογότυπου",
  "save": "Αποθήκευση",
  "delete": "Διαγραφή",
  "do_you_want_delete_post": "Να διαγραφεί αυτή η ανακοίνωση?",
  "match": "Αγώνας",
  "handlePlayers": "Συμμετέχοντες",
  "clubs": "Ακαδημίες",
  "team": "Ομάδα",
  "opponent": "Αντίπαλος",
  "opponentClub": "Αντίπαλη ακαδημία",
  "opponentTeam": "Αντίπαλη ομάδα",
  "competition": "Διοργάνωση",
  "club_admins": "Διαχειριστές ακαδημίας",
  "venue": "Έδρα",
  "date": "Ημερομηνία",
  "startTime": "Ώρα έναρξης",
  "endTime": "Ώρα λήξης",
  "location": "Τοποθεσία",
  "stadium": "στάδιο",
  "homeMatch": "Εντός",
  "training": "Προπόνηση",
  "repeat": "Επανάληψη",
  "everyWeek": "Κάθε εβδομάδα",
  "payment": "Πληρωμή",
  "next": "Επόμενο",
  "dueDate": "Προθεσμία",
  "amount": "Ποσό",
  "paymentPeriod": "Περίοδος πληρωμής",
  "monthlyPayments": "Μηνιαίες πληρωμές",
  "installment": "Δόση",
  "startingMonth": "Μήνας έναρξης",
  "endingMonth": "Μήνας λήξης",
  "allPlayers": "Όλοι οι παίκτες",
  "assigned": "Επιλεγμένοι",
  "searchPlayer": "Αναζήτηση παίκτη",
  "search_user": "Αναζήτηση Χρήστη",
  "filter": "Φίλτρο",
  "filter_by_player_name": "Φίλτρο ανά όνομα παίκτη",
  "unassignAll": "Αφαίρεση όλων",
  "assignAll": "Προσθήκη όλων",
  "createPayment": "Αποθήκευση",
  "price": "Τιμή",
  "installmentsOf": "δόσεις των",
  "installments": "Δόσεις",
  "includeInitialPayment": "Προσθήκη προκαταβολής",
  "initialPayment": "Προκαταβολή",
  "noOfPayments": "# δόσεων",
  "subscription": "Συνδρομή",
  "switch_to": "Αλλαγή σε",
  "current_plan": "Τρέχον πρόγραμμα",
  "renewal_date": "Ημερομηνία ανανέωσης",
  "subscriptions": "Συνδρομές",
  "active": "Ενεργή",
  "incomplete": "Μη ολοκληρωμένη",
  "incomplete_expired": "Μη ολοκληρωμένη (έληξε)",
  "past_due": "Έληξε",
  "paused": "Σε αναμονή",
  "trialing": "Σε Δοκιμαστική περίοδο",
  "unpaid": "Ανεξόφλητη",
  "active_subscriptions": "Ενεργές συνδρομές",
  "no_subscriptions_found": "Δε βρέθηκαν συνδρομές!",
  "active_seats": "Ενεργές θέσεις",
  "buy_more_seats": "Αγορά περισσότερων θέσεων",
  "downgrade_seats": "Μείωση θέσεων",
  "cancel_subscription": "Ακύρωση συνδρομής",
  "change_plan": "Αλλαγή προγράμματος",
  "renew_plan": "Ανανέωση προγράμματος",
  "invoice_details": "Στοιχεία τιμολογίου",
  "card_details": "Στοιχεία κάρτας",
  "teamware": "Ρουχισμός",
  "tournament": "Διοργάνωση",
  "tours": "Οδοιπορικά",
  "event": "Εκδήλωση",
  "other": "Άλλο",
  "oneOff": "Εφάπαξ",
  "oneOffDescription": "Δημιουργία πληρωμής με καταβολή όλου του ποσού σε 1 δόση.",
  "instalments": "Δόσεις",
  "instalmentsDescription": "Δημιουργία πληρωμής με καταβολή όλου του ποσού σε προκαθορισμένες δόσεις.",
  "monthly": "Μηνιαία",
  "monthlyDescription": "Δημιουργία πληρωμών με σταθερό ποσό που καταβάλλονται κάθε μήνα.",
  "paymentSuccessfullyPaid": "Η πληρωμή εξοφλήθηκε",
  "paymentSuccessfullyEdited": "Η πληρωμή ενημερώθηκε",
  "status": "Κατάσταση",
  "pending": "Εκκρεμεί",
  "completed": "Ολοκληρώθηκε",
  "abbreviation": "Συντομογραφία",
  "name": "Όνομα",
  "payment_table_header": "ΤΥΠΟΣ",
  "total_table_header": "ΠΟΣΟ",
  "dueDate_table_header": "ΠΡΟΘΕΣΜΙΑ",
  "paidOn_table_header": "ΠΛΗΡΩΘΗΚΕ",
  "edit": "Επεξεργασία",
  "member": "παίκτης",
  "of_player": "Παίκτη",
  "player": "Παίκτης",
  "deletePlayer": "Να διαγραφεί αυτός ο παίκτης?",
  "registered": "Ενεργοποιήθηκε",
  "pendingInvitation": "Εκκρεμής πρόσκληση",
  "rejected": "Απορρίφθηκε",
  "managedByParent": "Γονική διαχείριση",
  "mobile": "Κινητό",
  "playerUpdatedSuccessfully": "Το προφίλ παίκτη ενημερώθηκε",
  "playerCreatedSuccessfully": "Το προφίλ παίκτη δημιουργήθηκε",
  "back": "Πίσω",
  "firstName": "Όνομα",
  "lastName": "Επώνυμο",
  "yearOfBirth": "Έτος γέννησης",
  "position": "Θέση",
  "jerseyNumber": "Αριθμός φανέλας",
  "leagueUpdatedSuccessfully": "Η διοργάνωηση ενημερώθηκε",
  "leagueCreatedSuccessfully": "Η διοργάνωηση δημιουργήθηκε",
  "country": "Χώρα",
  "totalAcademies": "Σύνολο ακαδημιών",
  "activatedAcademies": "Ενεργές ακαδημίες",
  "matchReports": "Αναφορές αγώνα",
  "actions": "Ενέργειες",
  "searchLeagues": "Αναζήτηση διοργανώσεων",
  "league": "Διοργάνωση",
  "searchClubs": "Αναζήτηση Ακαδημιών",
  "academyCreatedSuccessfully": "Η ακαδημία δημιουργήθηκε επιτυχώς",
  "academyUpdatedSuccessfully": "Η ακαδημία ενημερώθηκε επιτυχώς",
  "members": "Μέλη",
  "staff": "Προσωπικό",
  "add_staff": "Προσθήκη προσωπικού",
  "parents": "Οι Γονείς μου",
  "my_teams": "Οι Ομάδες μου",
  "documents": "Αρχεία",
  "uploaded_at": "Έγινε upload",
  "activation": "Activation",
  "selectCountry": "Επιλογή χώρας",
  "selectPlan": "Επιλογή πλάνου",
  "selectTeam": "Επιλογή ομάδας",
  "searchAcademies": "Αναζήτηση ακαδημιών",
  "academy": "Ακαδημία",
  "competitions": "Διοργανώσεις",
  "logo": "Λογότυπο",
  "cover": "Cover",
  "email": "Email",
  "email_or_mobile": "Email ή κινητό",
  "error_invalid_phone_number": "Μη έγκυρος αριθμός τηλεφώνου",
  "error_invalid_email": "Μη έγκυρη διεύθυνση email",
  "error_invalid_date": "Μη έγκυρη ημερομηνία",
  "error_invalid_time": "Μη έγκυρη ώρα",
  "error_uploading_image": "Σφάλμα κατά το upload της εικόνας",
  "activeAcademy": "Active Academy",
  "participant": "Participant",
  "cancel": "Ακύρωση",
  "training_calendar": "ΠΡΟΠΟΝΗΣΗ",
  "eventSuccessfullyUpdated": "Η δραστηριότητα ενημερώθηκε",
  "updateCurrentOnly": "Θέλετε να ενημερώσετε μόνο την συγκεκριμένη προπόνηση?",
  "current": "Η συγκεκριμένη",
  "all": "Όλες οι μελλοντικές",
  "title": "Τίτλος",
  "participants": "Συμμετέχοντες ",
  "writeSomething": "Γράψε κάτι...",
  "eventType": "Τύπος",
  "phoneNumber": "Τηλέφωνο",
  "teamUpdatedSuccessfully": "Η ομάδα ενημερώθηκε",
  "teamCreatedSuccessfully": "Η ομάδα δημιουργήθηκε",
  "coaches": "Προπονητές",
  "coachCreatedSuccessfully": "Το προφίλ προπονητή δημιουργήθηκε",
  "coachUpdatedSuccessfully": "Το προφίλ προπονητή ενημερώθηκε",
  "coach": "Προπονητής",
  "managerControls": "Δυνατότητες διαχείρισης",
  "ageGroup": "Ηλικιακή κατηγορία",
  "settings": "Ρυθμίσεις",
  "logout": "Αποσύνδεση",
  "amountDescriptionStep1Oneoff": "Συμπλήρωσε το ποσό της πληρωμής.",
  "amountDescriptionStep1Instalment": "Συμπλήρωσε το συνολικό ποσό της πληρωμής και στη συνέχεια όρισε τον αριθμό των δόσεων.",
  "amountDescriptionStep1Monthly": "Συμπλήρωσε το ποσό της μηνιαίας δόσης.",
  "dateDescriptionStep2Oneoff": "Πότε θες να καταβληθεί η πληρωμή;",
  "dateDescriptionStep2Instalment": "Πότε θες να καταβληθεί η κάθε δόση;",
  "dateDescriptionStep2Monthly": "Όρισε το μήνα έναρξης και το μήνα λήξης της πληρωμής.",
  "playersDescription": "Επίλεξε τους παίκτες της ακαδημίας που αφορά η πληρωμή.",
  "totalPrice": "Συνολικό ποσό",
  "monthlyPrice": "Μηνιαία δόση",
  "selectAll": "Επιλογή όλων",
  "upcoming": "Επερχόμενα",
  "completed_calendar_filter": "Ολοκληρωμένα",
  "goalkeeper": "Τερματοφύλακας",
  "defender": "Αμυντικός",
  "midfielder": "Μέσος",
  "attacker": "Επιθετικός",
  "location_title": "Τοποθεσίας",
  "match_title": "Αγώνα",
  "training_title": "Προπόνησης",
  "change": "Αλλαγή",
  "doYouWant": "Θέλετε να",
  "currentOrAll": "μόνο το παρόν ή όλα τα μελλοντικά συμβάντα?",
  "cancel_verb": "ακυρώσετε",
  "delete_verb": "διαγράψετε",
  "general": "Γενικά",
  "players": "Παίκτες",
  "all_calendar_match": "Όλα",
  "completed_calendar_match": "Ολοκληρωμένα",
  "pending_calendar_match": "Σε εκκρεμότητα",
  "new_single": "Νέος",
  "match_single": "Αγώνας",
  "coach_single": "Προπονητής",
  "player_single": "Παίκτης",
  "attended": "Ήρθαν",
  "invited": "ΠΡΟΣΚΛΗΘΗΚΕ",
  "totalPercentage": "ΣΥΝΟΛΟ%",
  "verify": "Επιβεβαίωση",
  "activity": "Δραστηριότητα",
  "attendance": "Παρουσιολόγιο",
  "training_type": "Τύπος προπόνησης",
  "create_activity": "Νέα δραστηριότητα",
  "create_match": "Δημιουργία αγώνα",
  "create_training": "Δημιουργία προπόνησης",
  "create_event": "Δημιουργία εκδήλωσης",
  "the_match": "Ο αγώνας",
  "the_event": "Η εκδήλωση",
  "the_training": "Η προπόνηση",
  "deleted_successfully": "διαγράφηκε με επιτυχία",
  "from": "από",
  "for": "για",
  "referenceTo": "Αναφορά σε",
  "the_weekly_training": "Η εβδομαδιαία προπόνηση",
  "has_been": "έχει",
  "has": "έχει",
  "activity_cancelled": "ακυρωθεί",
  "are": "είναι",
  "have_been": "έχουν",
  "success_cancellation": "ακυρώθηκε με επιτυχία",
  "type_trainings": "Προπονήσεις",
  "activity_table_time": "Ώρα",
  "activity_table_date": "Ημερομηνία",
  "activity_table_team": "Ομάδα",
  "activity_table_activity": "Δραστηριότητα",
  "activity_table_location": "Τοποθεσία",
  "activity_table_participants": "Συμμετέχοντες",
  "create_match_title": "Αντίπαλος",
  "create_activity_team": "Ομάδα",
  "create_activity_date": "Έναρξη",
  "create_activity_from_time": "Από",
  "create_activity_to_time": "Διάρκεια",
  "create_training_end_date": "Έως",
  "create_training_schedule": "Επανάληψη",
  "create_activity_location": "Τοποθεσία",
  "create_activity_title": "Τίτλος",
  "notes": "Σημειώσεις",
  "no_teams_found": "Δε βρέθηκαν ομάδες.",
  "create_activity_teams": "Ομάδες",
  "create_activity_arrival": "Ώρα συνάντησης",
  "create_activity_rsvp_deadline": "Προθεσμία απάντησης",
  "create_activity_availableRsvps": "Διαθέσιμες απαντήσεις",
  "no_arrival_time": "Χωρίς συνάντηση",
  "15_minutes_before": "15 λεπτά πριν",
  "30_minutes_before": "30 λεπτά πριν",
  "45_minutes_before": "45 λεπτά πριν",
  "1_hour_before": "1 ώρα πριν",
  "1_hour_30_minutes_before": "1 ώρα και 30 λεπτά πριν",
  "2_hours_before": "2 ώρες πριν",
  "12_hours_before": "12 ώρες πριν",
  "1_day_before": "1 μέρα πριν",
  "2_days_before": "2 μέρες πριν",
  "1_week_before": "1 εβδομάδα πριν",
  "hour": "ώρα",
  "hours": "ώρες",
  "minutes": "λεπτά",
  "no_rsvp_deadline": "Χωρίς προθεσμία",
  "cannot_be_zero_or_negative": "δεν μπορεί να είναι μηδέν ή μικρότερο του μηδέν.",
  "cannot_be_negative": "δεν μπορεί να είναι μικρότερο του μηδέν.",
  "cannot_be_decimal": "δεν πρέπει να έχει δεκαδικά ψηφία.",
  "cannot_be_greater_than": "δεν μπορεί να είναι μεγαλύτερο από",
  "cannot_be_less_than": "δεν μπορεί να είναι μικρότερο από",
  "end_date": "ημερομηνία λήξης",
  "arrival_at": "Άφιξη στις",
  "back_to_schedule": "Πίσω στο ημερολόγιο",
  "back_to": "Πίσω στην",
  "participants_select_all": "Επιλογή όλων",
  "send_reminder": "Αποστολή υπενθύμισης",
  "reminder_sent": "Η υπενθύμιση απεστάλη",
  "created_successfully": "δημιουργήθηκε με επιτυχία",
  "updated_successfully": "ενημερώθηκε με επιτυχία",
  "new_weekly_training": "Νέα εβδομαδιαία προπόνηση",
  "event_participants_all": "Όλοι",
  "event_participants_players": "Παίκτες",
  "event_participants_admins": "Διαχειριστές",
  "event_participants_coaches": "Προπονητές",
  "event_participants_parents": "Γονείς",
  "view_activity": "Προβολή δραστηριότητας",
  "edit_activity": "Επεξεργασία δραστηριότητας",
  "cancel_activity": "Ακύρωση δραστηριότητας",
  "cancel_activities": "Ακύρωση δραστηριότητων",
  "delete_activity": "Διαγραφή δραστηριότητας",
  "time": "Ώρα",
  "cancel_activity_confirmation_msg": "Σίγουρα επιθυμείς την ακύρωση",
  "cancel_activity_confirmation_subtitle": "Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.",
  "delete_activity_confirmation_msg": "Σίγουρα επιθυμείς την διαγραφή",
  "delete_activity_confirmation_subtitle": "Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.",
  "these_activities": "αυτών των δραστηριότητων",
  "this_activity": "της δραστηριότητας",
  "reschedule_activity": "Αλλαγή ημέρας - ώρας & ενεργοποίηση δραστηριότητας",
  "reschedule_activities": "Αλλαγή ημέρας - ώρας & ενεργοποίηση δραστηριότητων",
  "reschedule_activity_confirmation_msg": "Σίγουρα επιθυμείς την αλλαγή ημέρας - ώρας & την ενεργοποίηση",
  "reschedule_activity_confirmation_subtitle": "Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.",
  "reschedule_future_events": "Ενημέρωση όλης της σειράς προπονήσεων",
  "reschedule": "Αλλαγή & Ενεργοποίηση",
  "reset_rsvps_on_activities": "Διαγραφή απαντήσεων (RSVP) στις δραστηριότητες",
  "reset_rsvps_on_activity": "Διαγραφή απαντήσεων (RSVP) στη δραστηριότητα",
  "reset_rsvps_confirmation_msg": "Έχετε επεξεργαστεί την ημερομηνία ή την ώρα έναρξης ή λήξης ή την τοποθεσία. Όλες οι απαντήσεις (RSVP) θα διαγραφούν για",
  "save_changes_on_trainings": "Αποθήκευση αλλαγών στις προπονήσεις",
  "save_changes_confirmation_msg": "Οι αλλαγές θα αποθηκευτούν σε όλη τη σειρά προπονήσεων. Είστε σίγουροι;",
  "close": "Κλείσιμο",
  "delete_activities": "Διαγραφή δραστηριότητων",
  "edit_event": "Επεξεργασία εκδήλωσης",
  "edit_training": "Επεξεργασία προπόνησης",
  "edit_match": "Επεξεργασία αγώνα",
  "view_post": "Προβολή ανακοίνωσης",
  "delete_post": "Διαγραφή ανακοίνωσης",
  "edit_post": "Επεξεργασία ανακοίνωσης",
  "the_post": "Η ανακοίνωση",
  "new_post": "Νέα ανακοίνωση",
  "all_teams": "Όλες οι ομάδες",
  "post_table_published_date": "Ημ/νία ανακοίνωσης",
  "post_table_title": "Τίτλος",
  "post_table_team": "Ομάδα",
  "post_table_editor": "Συντάκτης",
  "post_table_reactions": "Αντιδράσεις",
  "post_table_views": "Εμφανίσεις",
  "delete_post_warning_msg": "Επιθυμείς σίγουρα την διαγραφή της ανακοίνωσης?",
  "create_post_text": "Κείμενο",
  "create": "Δημιουργία",
  "post_edit": "Επεξεργασία",
  "create_post": "Ανακοίνωσης",
  "post_training": "Ανακοίνωση προπόνησης",
  "post_match": "Ανακοίνωση αγώνα",
  "post_event": "Ανακοίνωση εκδήλωσης",
  "post_deleted_successfully": "Η ανακοίνωση διαγράφηκε με επιτυχία",
  "post_photo_cover": "Εικόνα (εξώφυλλο)",
  "post_form_description": "Δημιουργήστε την ανακοίνωση και επιλέξτε τι θα βλέπουν και θα μπορούν να κατεβάσουν τα μέλη.",
  "post_details_title": "Στοιχεία ανακοίνωσης",
  "post_details_description": "Προσθέστε το μήνυμα και επιλέξτε τις ομάδες που θα το λάβουν.",
  "post_media_title": "Φωτογραφίες και βίντεο",
  "post_media_description": "Εμφανίζονται μέσα στην ανακοίνωση.",
  "post_media_upload": "Προσθήκη φωτογραφιών ή βίντεο",
  "post_attachments_description": "Αρχεία που τα μέλη μπορούν να ανοίξουν ή να κατεβάσουν.",
  "post_attachments_upload": "Μεταφόρτωση PDF από τη συσκευή",
  "post_choose_shared_files": "Επιλογή από τα αρχεία της ακαδημίας",
  "post_shared_files_team_hint": "Επιλέξτε τουλάχιστον μία ομάδα για να χρησιμοποιήσετε αρχεία της ακαδημίας.",
  "post_create_action": "Δημιουργία ανακοίνωσης",
  "post_save_action": "Αποθήκευση αλλαγών",
  "share_with": "Κοινοποίηση σε",
  "share": "Κοινοποίηση",
  "the_file": "Το αρχείο",
  "the_files": "Τα αρχεία",
  "file": "Αρχείο",
  "files": "Αρχεία",
  "files_subtitle": "Στείλε αρχεία σε ομάδες ή σε συγκεκριμένους παίκτες της ακαδημίας και διαχειρίσου τα.",
  "size": "Μέγεθος",
  "image_file": "Εικόνα",
  "video_file": "Βίντεο",
  "pdf_file": "PDF",
  "download": "Λήψη",
  "open_file": "Άνοιγμα αρχείου",
  "preview_file": "Προεπισκόπηση αρχείου",
  "file_preview_unavailable": "Δεν είναι διαθέσιμη η προεπισκόπηση αυτού του αρχείου. Επιλέξτε λήψη για να το ανοίξετε.",
  "download_file": "Λήψη αρχείου",
  "delete_file": "Διαγραφή αρχείου",
  "share_file": "Κοινοποίηση αρχείου",
  "unshare_file": "Αφαίρεση αρχείου",
  "file_successfully_downloaded": "Έγινε λήψη (download) του αρχείου με επιτυχία",
  "file_successfully_deleted": "Το αρχείο διαγράφηκε με επιτυχία",
  "file_successfully_shared": "Το αρχείο κοινοποιήθηκε με επιτυχία",
  "file_successfully_unshared": "Το αρχείο αφαιρέθηκε με επιτυχία",
  "error_download_file": "Σφάλμα κατά τη λήψη (download) του αρχείου",
  "file_download_failed_help": "Δεν ήταν δυνατή η λήψη του αρχείου. Δοκιμάστε ξανά ή ανοίξτε το σε νέα καρτέλα και αποθηκεύστε το από το πρόγραμμα περιήγησης.",
  "no_files_found": "Δε βρέθηκαν αρχεία.",
  "upload": "Μεταφόρτωση",
  "upload_files": "Μεταφόρτωση αρχείων",
  "post_attachment_upload_failed": "Δεν ήταν δυνατή η μεταφόρτωση του συνημμένου της ανακοίνωσης. Δοκιμάστε ξανά.",
  "click_to_upload": "Κάντε κλικ για μεταφόρτωση",
  "drag_n_drop": "ή σύρετε και αποθέστε",
  "drop_files_here": "Αφήστε τα αρχεία εδώ ...",
  "image_upload_files": "WEBP, SVG, PNG, JPG, HEIC ή GIF (έως 800x400 px και 15 MB)",
  "video_upload_files": "MP4, MPEG ή AVI (έως 15 MB)",
  "document_upload_files": "PDF (έως 15 MB)",
  "invalid_file_type": "Μη έγκυρος τύπος αρχείου. Μεταφορτώστε ένα έγκυρο αρχείο.",
  "invalid_file_size": "Μη έγκυρο μέγεθος αρχείου. Μεταφορτώστε ένα αρχείο μικρότερο από 15 MB.",
  "add_file": "Προσθήκη αρχείου",
  "replace_file": "Αντικατάσταση αρχείου",
  "club_page_title": "Ακαδημία",
  "club_page_subtitle": "Δημιούργησε ομάδες, μοιράσου τους κωδικούς τους και δες όλα τα προφίλ των παικτών της ακαδημίας.",
  "club_page_add_team": "Νέα ομάδα",
  "players_page_title": "Παίκτες",
  "players_page_subtitle": "Δημιούργησε προφίλ παικτών, δες ποιοι έχουν συνδεθεί στην εφαρμογή και διαχειρίσου τα στοιχεία τους.",
  "players_stats_total": "Σύνολο παικτών",
  "club_stats_total": "Σύνολο ομάδων",
  "staff_stats_total": "Σύνολο προσωπικού",
  "players_page_summary": "{{players}} παίκτες σε {{teams}} ομάδες",
  "players_export": "Εξαγωγή",
  "players_exporting": "Γίνεται εξαγωγή...",
  "players_export_failed": "Δεν ήταν δυνατή η εξαγωγή των παικτών.",
  "players_new_player": "Νέος παίκτης",
  "team_required_title": "Δημιουργήστε πρώτα μια ομάδα",
  "team_required_players": "Για να καταχωρήσετε παίκτες, πρέπει πρώτα να δημιουργήσετε τουλάχιστον μία ομάδα.",
  "team_required_activities": "Για να καταχωρήσετε δραστηριότητες, πρέπει πρώτα να δημιουργήσετε τουλάχιστον μία ομάδα.",
  "players_select_team": "Επιλέξτε ομάδα",
  "players_search_placeholder": "Αναζήτηση παικτών",
  "players_filter_team": "Ομάδα",
  "players_filter_status": "Κατάσταση",
  "players_filter_documents": "Έγγραφα",
  "players_filter_gdpr": "GDPR",
  "players_column_gdpr": "GDPR",
  "players_gdpr_accepted": "Αποδεκτό",
  "players_gdpr_missing": "Λείπει",
  "players_gdpr_stale": "Χρειάζεται ανανέωση",
  "players_gdpr_not_required": "Δεν απαιτείται",
  "players_gdpr_unknown": "Άγνωστο",
  "players_filter_accounts": "Λογαριασμοί",
  "players_filter_balance": "Υπόλοιπο",
  "players_filter_age_group": "Ηλικιακή ομάδα",
  "players_columns": "Στήλες",
  "players_column_player": "Παίκτης",
  "players_column_team": "Ομάδα",
  "players_column_date_of_birth": "Ημερομηνία γέννησης",
  "players_column_guardian": "Κηδεμόνας",
  "players_column_status": "Κατάσταση",
  "players_column_documents": "Έγγραφα",
  "players_column_balance": "Υπόλοιπο",
  "table_sort_example_title": "Σύνθεση κεφαλίδων με ταξινόμηση, χωρίς ταξινόμηση και σε απενεργοποιημένη κατάσταση",
  "table_sort_example_caption": "Προεπισκόπηση σημασιολογικής συμπεριφοράς ταξινόμησης· τα οπτικά στοιχεία παραγωγής εκκρεμούν",
  "table_sort_state_none": "χωρίς ταξινόμηση",
  "table_sort_state_ascending": "ταξινόμηση σε αύξουσα σειρά",
  "table_sort_state_descending": "ταξινόμηση σε φθίνουσα σειρά",
  "table_sort_action_ascending": "ταξινόμηση σε αύξουσα σειρά",
  "table_sort_action_descending": "ταξινόμηση σε φθίνουσα σειρά",
  "table_sort_button_label": "{{column}}: {{current}}. Ενεργοποιήστε για {{next}}.",
  "table_sort_unavailable": "Η ταξινόμηση για τη στήλη {{column}} δεν είναι διαθέσιμη αυτή τη στιγμή.",
  "table_sort_example_available": "Διαθέσιμος",
  "table_sort_example_player": "Ποδοσφαιριστής με ιδιαίτερα μεγάλο μεταφρασμένο όνομα",
  "table_sort_example_team": "Ακαδημία",
  "players_status_registered": "Εγγεγραμμένος",
  "players_status_registered_managed": "Εγγεγραμμένος · Με κηδεμόνα",
  "players_status_managed": "Διαχείριση από κηδεμόνα",
  "players_status_pending": "Εκκρεμεί",
  "players_status_unclaimed": "Μη συνδεδεμένος",
  "players_status_unknown": "Άγνωστη κατάσταση",
  "players_documents_complete": "Πλήρη",
  "players_documents_missing": "Ελλιπή",
  "players_documents_missing_count": "Ελλιπή: {{count}}",
  "players_documents_expired": "Ληγμένα",
  "players_documents_unknown": "Άγνωστη κατάσταση",
  "players_balance_has_balance": "Με υπόλοιπο",
  "players_balance_no_balance": "Χωρίς υπόλοιπο",
  "players_balance_unknown": "Άγνωστο",
  "players_table_label": "Παίκτες ακαδημίας",
  "players_select_all": "Επιλογή όλων των παικτών στη σελίδα",
  "players_select_player": "Επιλογή παίκτη",
  "players_view_player": "Προβολή παίκτη",
  "players_no_results": "Δεν υπάρχουν παίκτες που να ταιριάζουν στα φίλτρα.",
  "table_rows_per_page": "Γραμμές ανά σελίδα",
  "table_pagination_of": "από",
  "select_example_title": "Επιλογή μεγέθους σελίδας",
  "select_example_caption": "Ο καταναλωτής διαχειρίζεται τις διαθέσιμες τιμές, την επαναφορά της σελιδοποίησης και την προσαρμοζόμενη διάταξη του υποσέλιδου.",
  "select_selected_value": "Επιλεγμένο μέγεθος σελίδας: {{value}}",
  "pagination_example_title": "Στοιχεία ελέγχου σελιδοποίησης",
  "pagination_example_caption": "Ο καταναλωτής διαχειρίζεται την κατάσταση σελίδας, τους υπολογισμούς, τις μεταφρασμένες ετικέτες, τα εικονίδια και τις ανακοινώσεις.",
  "pagination_navigation_label": "Σελίδες",
  "pagination_first_page": "Πρώτη σελίδα",
  "pagination_previous_page": "Προηγούμενη σελίδα",
  "pagination_next_page": "Επόμενη σελίδα",
  "pagination_last_page": "Τελευταία σελίδα",
  "pagination_page_summary": "Σελίδα {{page}} από {{total}}",
  "players_load_failed": "Δεν ήταν δυνατή η φόρτωση των παικτών.",
  "players_retry": "Επανάληψη",
  "sport": "Άθλημα",
  "edit_team": "Επεξεργασία ομάδας",
  "team_name": "Όνομα",
  "gender": "Γένος",
  "team_code": "Κωδικός",
  "the_team": "Η ομάδα",
  "create_team": "Ομάδας",
  "locked_successfully": "κλειδώθηκε με επιτυχία",
  "unlocked_successfully": "ξεκλειδώθηκε με επιτυχία",
  "lock_team": "Κλείδωμα ομάδας",
  "unlock_team": "Ξεκλείδωμα ομάδας",
  "generate_team_code": "Δημιουργία νέου κωδικού ομάδας",
  "the_team_code": "Ο νέος κωδικός ομάδας",
  "generated_successfully": "δημιουργήθηκε επιτυχώς",
  "football": "Ποδόσφαιρο",
  "basket": "Μπάσκετ",
  "boys": "Αγόρια",
  "girls": "Κορίτσια",
  "edit_team_info": "Επεξεργασία πληροφοριών ομάδας",
  "edit_club_info": "Επεξεργασία πληροφοριών ακαδημίας",
  "manage_players": "Διαχείριση παικτών",
  "add_new_player": "Προσθήκη",
  "back_to_team": "Πίσω στην ομάδα",
  "move_players_to_other_teams": "Μετακίνηση",
  "select_teams_to_move_or_copy_players": "Επιλέξτε ομάδα-ες για μετακίνηση ή αντιγραφή παικτών",
  "copy_players": "Αντιγραφή",
  "move_players": "Μετακίνηση",
  "no_players_found": "Δε βρέθηκαν παίκτες.",
  "selected_players_successfully_moved": "Οι επιλεγμένοι παίκτες μετακινήθηκαν με επιτυχία",
  "selected_players_successfully_copied": "Οι επιλεγμένοι παίκτες αντιγράφηκαν με επιτυχία",
  "error_move_selected_player": "Πρόβλημα στη μετακίνηση του επιλεγμένου παίκτη",
  "error_copy_selected_player": "Πρόβλημα στην αντιγραφή του επιλεγμένου παίκτη",
  "squad": "Ομάδα",
  "team_parents": "Γονείς",
  "edit_profile": "Επεξεργασία προφίλ",
  "create_profile": "Δημιουργία προφίλ",
  "player_create_subtitle": "Προσθέστε προσωπικά στοιχεία, ομάδα, ιατρικές πληροφορίες και έγγραφα.",
  "player_edit_subtitle": "Ενημερώστε τα προσωπικά στοιχεία, τις ομάδες, τις ιατρικές πληροφορίες και τα έγγραφα.",
  "player_personal_details": "Προσωπικά στοιχεία",
  "player_personal_details_subtitle": "Στοιχεία επικοινωνίας και βασικές πληροφορίες του παίκτη.",
  "player_membership_details": "Ομάδα και προφίλ",
  "player_membership_details_subtitle": "Ομάδες, δημογραφικά στοιχεία και φωτογραφία προφίλ.",
  "search": "Αναζήτηση",
  "enter_phone_msg": "Εισαγάγετε τον αριθμό τηλεφώνου σας και στη συνέχεια θα σας στείλουμε έναν 6ψήφιο \n κωδικό για να επαληθεύσουμε τον αριθμό τηλεφώνου σας.",
  "login_through_mobile_app": "Δεν έχετε πρόσβαση στο PlayerDex Manager. Παρακαλώ συνδεθείτε (log in) μέσω του app στο κινητό σας τηλέφωνο δωρεάν!",
  "otp_code": "OTP Code",
  "remember_me": "Θυμήσου με",
  "confirm_code": "Επιβεβαίωση κωδικού",
  "sign_in": "Σύνδεση",
  "loadMore": "Φόρτωσε περισσότερα",
  "send": "Αποστολή",
  "and_every": "και καθε",
  "newFemale": "Νέα",
  "and": "και",
  "updateAllFutureEvents": "Ενημέρωση όλης της σειράς προπονήσεων",
  "daily_training": "Ημερήσια",
  "weekly_training": "Εβδομαδιαία",
  "no_repeated_training": "Όχι",
  "athletics": "Στίβος",
  "basketball": "Μπάσκετ",
  "americanFootball": "Αμερικανικό ποδόσφαιρο",
  "archery": "Τοξοβολία",
  "badminton": "Μπάντμιντον",
  "baseball": "Μπέιζμπολ",
  "boxing": "Μποξ",
  "cricket": "Κρίκετ",
  "cycling": "Ποδηλασία",
  "esports": "Esports",
  "fencing": "Ξιφασκία",
  "fieldHockey": "Χόκεϊ επί χόρτου",
  "gymnastics": "Ενόργανη",
  "golf": "Γκολφ",
  "handball": "Χάντμπολ",
  "horseRiding": "Ιππασία",
  "iceHockey": "Χόκεϊ επί πάγου",
  "martialArts": "Πολεμικές τέχνες",
  "padel": "Πάντελ",
  "pingPong": "Πινγκ πονγκ",
  "rugby": "Ράγκμπι",
  "sailing": "Ιστιοπλοΐα",
  "shootingSport": "Σκοποβολή",
  "skiing": "Χειμερινά σπορ",
  "swimming": "Κολύμβηση",
  "tennis": "Τέννις",
  "volleyball": "Βόλλεϋ",
  "waterSports": "Θαλάσσια σπορ",
  "waterPolo": "Πόλο",
  "notifications": "Ειδοποιήσεις",
  "notifications_title": "Ειδοποιήσεις",
  "notifications_subtitle": "Διαχειρίσου τα αιτήματα γονεών και προπονητών για πρόσβαση στο app.",
  "deny": "Απόρριψη",
  "give_access": "Αποδοχή",
  "role": "Ρόλος",
  "user": "Χρήστης",
  "no_notifications_found": "Δε βρέθηκαν ειδοποιήσεις.",
  "user_invitations": "Προσκλήσεις χρηστών",
  "invitation_from": "Από",
  "parent": "Γονέας",
  "invitation_player": "Παίκτης",
  "team_admin": "Διαχειριστής Ομάδας",
  "club_admin": "Διαχειριστής Ακαδημίας",
  "remove_club_admin": "Αφαίρεση Διαχειριστή Ακαδημίας",
  "remove": "Αφαίρεση",
  "add": "Προσθήκη",
  "areYouSureYouWantToDeleteThisTeam": "Είστε σίγουροι ότι θέλετε να διαγράψετε αυτή την ομάδα",
  "deleteTeam": "Διαγραφή ομάδας",
  "couldntDeleteTeam": "Η διαγραφή ομάδας απέτυχε",
  "pleaseMakeSureThereAreNoPlayersInTeamBeforeDeleteIt": "Παρακαλώ βεβαιωθείτε ότι δεν υπάρχουν παίκτες στην ομάδα πριν την διαγράψετε",
  "areYouSureYouWantToDeleteThisPlayer": "Είστε σίγουροι ότι θέλετε να διαγράψετε αυτόν τον παίκτη",
  "mixed": "Ανάμεικτα",
  "removeParent": "Αφαίρεση γονέα",
  "areYouSureYouWantToDeleteThisParent": "Είστε σίγουροι ότι θέλετε να αφαιρέσετε τον γονέα",
  "fromPlayer": "από τον παίκτη",
  "remove_user": "Αφαίρεση χρήστη",
  "removePlayerFromUser": "Αφαίρεση παίκτη από τον χρήστη",
  "areYouSureYouWantToRemoveThisPlayerFromTheUser": "Είστε σίγουροι ότι θέλετε να αφαιρέσετε τον παίκτη από τον χρήστη",
  "removePlayerFromTeam": "Αφαίρεση παίκτη από την ομάδα",
  "removeStaffFromTeam": "Αφαίρεση μέλους προσωπικού από την ομάδα",
  "removeStaffFromTeamConfirmation": "Είστε σίγουροι ότι θέλετε να αφαιρέσετε τον/την {{name}} από την ομάδα {{team}};",
  "areYouSureYouWantToRemoveThisPlayer": "Είστε σίγουροι ότι θέλετε να αφαιρέσετε τον/την {{firstName}} {{lastName}} από την ομάδα {{team}};",
  "fromTheTeam": "από την ομάδα",
  "successfullyDeletedPlayer": "Ο παίκτης διαγράφτηκε με επιτυχία",
  "successfullyUserFromPlayer": "Ο παίκτης αφαιρέθηκε με επιτυχία από τον χρήστη",
  "successfullyAddedPlayer": "Ο παίκτης δημιουργήθηκε με επιτυχία",
  "add_product": "Νέο προϊόν",
  "shop": "Κατάστημα",
  "shop_page_subtitle": "Δημιούργησε προϊόντα και συνδρομές, χρέωσέ τα στα μέλη και παρακολούθησε τα έσοδα της ακαδημίας.",
  "back_to_shop": "Πίσω στο κατάστημα",
  "product_not_found": "Το προϊόν δεν βρέθηκε.",
  "product_name": "Όνομα Προϊόντος",
  "stock": "Στοκ",
  "back_to_products": "Πίσω στα Προϊόντα",
  "no_products_found": "Δε βρέθηκαν προϊόντα.",
  "shop_add_product_details": "Πληροφορίες προϊόντος",
  "shop_add_product_details_subtitle": "Οι πληροφορίες για το προϊόν",
  "shop_add_product_name_placeholder": "Το όνομα προϊόντος",
  "shop_add_product_price_and_stock": "Τιμή και στοκ",
  "shop_add_product_price_and_stock_subtitle": "Η τιμή και το στοκ των προϊόντων",
  "shop_add_product_description": "Περιγραφή",
  "shop_add_product_description_subtitle": "Περιγραφή του προϊόντος",
  "shop_add_product_photo": "Φωτογραφία",
  "shop_add_product_photo_subtitle": "Ενημερώστε την φωτογραφία του προϊόντος",
  "shop_add_product_price_and_stock_placeholder": "Προσθεστε στοκ. Αφήστε το κενό άμα δεν έχει.",
  "characters_left": "Χαρακτήρες που απομένουν",
  "product_successfully_created": "Το προϊόν δημιουργήθηκε με επιτυχία",
  "create_product": "Νέο προϊόν",
  "edit_product": "Επεξεργασία προϊόντος",
  "delete_product": "Διαγραφή προϊόντος",
  "create_payment": "Νέα πληρωμή",
  "product_successfully_updated": "Το προϊόν ενημερώθηκε με επιτυχία",
  "show_deleted_players": "Εμφάνιση διαγραμμένων παικτών",
  "hide_deleted_players": "Απόκρυψη διαγραμμένων παικτών",
  "no_payments_found": "Δε βρέθηκαν πληρωμές.",
  "add_payments": "Νέα πληρωμή",
  "add_payments_subtitle": "Δημιουργήστε πληρωμές για παίκτες",
  "payment_method": "Μέθοδος πληρωμής",
  "cash": "Μετρητά",
  "card": "Κάρτα",
  "payment_transfer": "Τραπεζική μεταφορά",
  "discount_type": "Είδος έκπτωσης",
  "fixed": "Σταθερό",
  "percent": "Ποσοστό",
  "discount": "Έκπτωση",
  "new_payment": "Νέα Πληρωμή",
  "durationInMonths": "Διάρκεια σε μήνες",
  "order_created_successfully": "Η παραγγελία δημιουργήθηκε με επιτυχία",
  "initialAmount": "Αρχική τιμή",
  "player_table_column": "Παίκτης",
  "payment_type": "Είδος πληρωμής",
  "payment_status": "Κατάσταση πληρωμής",
  "draft": "Προγραμματισμένη",
  "undo_payment": "Αναίρεση πληρωμής",
  "shop_loading_impact": "Υπολογισμός των αλλαγών…",
  "shop_review_impact": "Επανέλεγχος αλλαγών",
  "shop_impact_unavailable": "Δεν ήταν δυνατός ο υπολογισμός των αλλαγών. Ελέγξτε ξανά πριν από την επιβεβαίωση.",
  "shop_impact_changed": "Τα στοιχεία άλλαξαν μετά την προεπισκόπηση. Ελέγξτε τις ενημερωμένες αλλαγές και επιβεβαιώστε ξανά.",
  "SHOP_ACTION_CHANGED": "Τα στοιχεία άλλαξαν μετά την προεπισκόπηση. Ελέγξτε τις ενημερωμένες αλλαγές και επιβεβαιώστε ξανά.",
  "shop_impact_all_time": "Η ενέργεια αφορά όλες τις ημερομηνίες, πέρα από την επιλεγμένη σεζόν και τα φίλτρα.",
  "shop_affected_orders": "Συνδεδεμένες παραγγελίες",
  "shop_deleted_orders": "Παραγγελίες που διαγράφονται",
  "shop_affected_payments": "Πληρωμές που επηρεάζονται",
  "shop_deleted_payments": "Πληρωμές που διαγράφονται",
  "shop_monthly_payments": "Μηνιαίες πληρωμές",
  "shop_revenue_change": "Μεταβολή εισπραχθέντων εσόδων",
  "shop_outstanding_change": "Μεταβολή ανεξόφλητου υπολοίπου",
  "shop_payment_total_change": "Μεταβολή συνόλου πληρωμών",
  "shop_order_value_change": "Μεταβολή αξίας παραγγελιών",
  "shop_payment_returns_to": "Νέα κατάσταση πληρωμής",
  "shop_undo_schedule_note": "Διατηρείται η αρχική ημερομηνία λήξης. Αν έχει παρέλθει, η πληρωμή γίνεται ληξιπρόθεσμη· διαφορετικά γίνεται προγραμματισμένη.",
  "shop_financial_changes_note": "Οι μεταβολές αφορούν όλες τις ημερομηνίες. Το σύνολο πληρωμών εξαιρεί τις ακυρωμένες· το ανεξόφλητο υπόλοιπο περιλαμβάνει προγραμματισμένες και ληξιπρόθεσμες πληρωμές. Η αξία παραγγελιών εμφανίζεται χωριστά.",
  "shop_no_refund_note": "Αλλάζουν μόνο οι καταχωρίσεις σας. Δεν πραγματοποιείται επιστροφή ή μεταφορά χρημάτων.",
  "shop_undo_paid_note": "Η πληρωμή επανέρχεται ως ανεξόφλητη με το αποθηκευμένο ποσό και την ημερομηνία λήξης της. Η καταχωρισμένη είσπραξη αφαιρείται από τα έσοδα. Οι υπόλοιπες πληρωμές και δόσεις δεν αλλάζουν.",
  "shop_undo_cancelled_note": "Η ακυρωμένη πληρωμή επανέρχεται ως ανεξόφλητη με το αποθηκευμένο ποσό και την ημερομηνία λήξης της. Προστίθεται ξανά στο ανεξόφλητο υπόλοιπο. Οι υπόλοιπες πληρωμές και δόσεις δεν αλλάζουν.",
  "shop_delete_order_note": "Διαγράφονται η παραγγελία και όλες οι πληρωμές της: εξοφλημένες, αρχικές, μηνιαίες και δόσεις. Αφαιρούνται τα αντίστοιχα καταχωρισμένα έσοδα, ανεξόφλητα υπόλοιπα και σύνολα. Το απόθεμα προϊόντων παραμένει ίδιο.",
  "shop_product_delete_scope": "Τι θέλετε να διαγραφεί;",
  "shop_delete_catalog_only": "Αφαίρεση μόνο από το κατάστημα",
  "shop_delete_product_everywhere": "Αφαίρεση και από υπάρχουσες παραγγελίες",
  "shop_delete_catalog_note": "Το προϊόν αφαιρείται από το κατάστημα. Οι υπάρχουσες παραγγελίες, τα προγράμματα πληρωμών, τα εισπραχθέντα έσοδα και τα σύνολα παραμένουν ίδια.",
  "shop_delete_cascade_note": "Το προϊόν αφαιρείται από κάθε συνδεδεμένη παραγγελία, ακόμη και εξοφλημένη. Οι άδειες παραγγελίες και όλες οι πληρωμές τους διαγράφονται. Αν παραμένουν άλλα προϊόντα, όλα τα ποσά πληρωμών, ακόμη και εξοφλημένα ή ακυρωμένα, μειώνονται αναλογικά· ημερομηνίες και καταστάσεις διατηρούνται. Περιλαμβάνονται οι μηνιαίες πληρωμές και οι δόσεις.",
  "paid": "Πληρωμένη",
  "due": "Ληξιπρόθεσμη",
  "shop_all_payments": "Όλες οι πληρωμές (εισπράξεις / σύνολο)",
  "shop_totals_unavailable": "Τα σύνολα πληρωμών δεν είναι διαθέσιμα.",
  "SHOP_PAYMENT_SNAPSHOT_UNAVAILABLE": "Δεν υπάρχουν αποθηκευμένα στοιχεία προϊόντων για αυτήν την πληρωμή. Οι αλλαγές δεν μπορούν να υπολογιστούν με ασφάλεια.",
  "SHOP_PAYMENT_ORDER_UNAVAILABLE": "Η συνδεδεμένη παραγγελία δεν είναι διαθέσιμη. Ανανεώστε τη σελίδα και ελέγξτε ξανά.",
  "SHOP_PAYMENT_NOT_REOPENABLE": "Αναίρεση επιτρέπεται μόνο για εξοφλημένες ή ακυρωμένες πληρωμές. Ανανεώστε τη σελίδα για την τρέχουσα κατάσταση.",
  "SHOP_ACTION_INVALID_INPUT": "Η ενέργεια δεν είναι διαθέσιμη. Ανανεώστε τη σελίδα και δοκιμάστε ξανά.",
  "SHOP_ACTION_INVALID_AMOUNT": "Τα αποθηκευμένα ποσά δεν συμφωνούν. Ελέγξτε τα ποσά της παραγγελίας και των πληρωμών πριν συνεχίσετε.",
  "cancelled": "Ακυρωμένη",
  "payment_already_paid": "Η πληρωμή είναι ήδη πληρωμένη",
  "pay_this_payment": "Ολοκληρώστε αυτή την πληρωμή",
  "are_you_sure_want_to_pay_this_payment": "Είστε σίγουροι ότι θέλετε να ολοκληρώσετε αυτή την πληρωμή?",
  "pay": "Ολοκληρώστε",
  "payment_paid_successfully": "Η πληρωμή ολοκληρώθηκε",
  "pay_payment": "Ολοκλήρωση πληρωμής",
  "send_notification": "Αποστολή ειδοποίησης",
  "are_you_sure_want_to_send_notification_for_this_overdue_payment": "Είστε σίγουροι ότι θέλετε να στείλετε ειδοποίηση για αυτήν την ληξιπρόθεσμη πληρωμή?",
  "notification_sent_successfully": "Η ειδοποίηση στάλθηκε με επιτυχία",
  "academy_revenue": "Έσοδα ακαδημίας",
  "academy_revenue_subtitle": "Παρακολουθήστε τις εισπράξεις μελών και ενημερώστε όσους έχουν ληξιπρόθεσμες οφειλές.",
  "collected_revenue": "Εισπραχθέντα έσοδα",
  "revenue_transactions": "Πληρωμές που εισπράχθηκαν",
  "revenue_period": "Περίοδος εσόδων",
  "revenue_grouping": "Ομαδοποίηση εσόδων",
  "revenue_today": "Σήμερα",
  "revenue_this_week": "Αυτή την εβδομάδα",
  "revenue_this_month": "Αυτόν τον μήνα",
  "revenue_season": "Σεζόν",
  "revenue_custom": "Προσαρμοσμένο",
  "revenue_daily": "Ανά ημέρα",
  "revenue_weekly": "Ανά εβδομάδα",
  "revenue_monthly": "Ανά μήνα",
  "no_revenue_data": "Δεν καταγράφηκαν εξοφλημένες πληρωμές μελών για αυτή την περίοδο.",
  "legacy_revenue_note": "Για ορισμένες παλαιότερες πληρωμές χρησιμοποιείται η τελευταία ημερομηνία ενημέρωσης ως ημερομηνία πληρωμής.",
  "notify_overdue_payers": "Ειδοποίηση οφειλετών",
  "overdue_reminder_confirmation": "Να σταλεί μία υπενθύμιση ανά παίκτη και νόμισμα για όλες τις επιλέξιμες ληξιπρόθεσμες πληρωμές;",
  "eligible_payers": "Επιλέξιμοι οφειλέτες",
  "overdue_payments": "Ληξιπρόθεσμες πληρωμές",
  "overdue_balance": "Ληξιπρόθεσμο υπόλοιπο",
  "payers": "οφειλέτες",
  "payment_reminder_cooldown_note": "Όσοι ειδοποιήθηκαν τις τελευταίες 24 ώρες θα παραλειφθούν.",
  "payment_reminders_sent": "Ειδοποιήσεις που στάλθηκαν",
  "payment_reminders_skipped": "Οφειλέτες που παραλείφθηκαν",
  "payment_reminders_failed": "Αποτυχημένες παραδόσεις",
  "notification_sent": "Έχει σταλεί ειδοποίηση",
  "create_product_subscription": "Συνδρομή",
  "create_product_teamware": "Ρουχισμός ",
  "create_product_event": "Εκδήλωση",
  "create_product_tournament": "Τουρνουά",
  "create_product_tours": "Οδοιπορικά",
  "create_product_other": "Άλλο",
  "per_month": "μηνιαία",
  "repeats_monthly": "Επαναλαμβάνεται μηνιαία",
  "total": "Σύνολο",
  "per_player": "Ανά παίκτη",
  "shop_add_product_price": "Τιμή προϊόντος",
  "cancel_this_payment": "Ακύρωση πληρωμής ",
  "are_you_sure_want_to_cancel_this_payment": "Είστε σίγουροι ότι θέλετε να ακυρώσετε αυτήν την πληρωμή?",
  "payment_cancelled_successfully": "Η πληρωμή ακυρώθηκε με επιτυχία",
  "order_successfully_deleted": "Η παραγγελία διαγράφτηκε με επιτυχία",
  "delete_order": "Διαγραφή παραγγελίας",
  "are_you_sure_want_to_delete_this_order": "Είστε σίγουροι ότι θέλετε να διαγράψετε αυτήν την παραγγελία?",
  "all_types": "Όλοι οι τύποι",
  "all_coaches": "Όλοι οι προπονητές",
  "all_players": "Όλοι οι παίκτες",
  "all_categories": "Όλες οι κατηγορίες",
  "category": "Κατηγορία",
  "show_all": "Όλα",
  "cancel_payment": "Ακύρωση πληρωμής",
  "payments": "Πληρωμές",
  "orders": "Παραγγελίες",
  "paidOn": "Πληρώθηκε",
  "product_successfully_delete": "Το προϊόν διαγράφηκε με επιτυχία",
  "error_not_enough_stock": "Το στοκ δεν είναι επαρκές για αυτήν την παραγγελία",
  "need_to_select_players": "Πρέπει να προσθέσετε τουλάχιστον έναν παίκτη",
  "going": "Θα πάει",
  "notAttended": "Δεν ήρθαν",
  "notGoing": "Δε θα πάει",
  "notAnswered": "Δεν απάντησε",
  "attended_player": "Παρουσίες",
  "notAttended_player": "Απουσίες",
  "activities": "Δραστηριότητες",
  "send_code": "Αποστολή κωδικού",
  "insert_code": "Εισάγετε τον κωδικό",
  "contacts": "Επαφές",
  "never_loggedIn": "Καμία σύνδεση",
  "connected": "Συνδέθηκε",
  "online": "Σε σύνδεση",
  "managed_by_parents": "Διαχειρίζεται από γονέα",
  "order_summary": "Πληροφορίες παραγγελίας",
  "assignments": "Αναθέσεις",
  "deleted_player": "Διαγραμμένος παίκτης",
  "are_you_sure_you_want_to_logout": "Είστε σίγουροι ότι θέλετε να αποσυνδεθείτε?",
  "home_match": "Εντός έδρας",
  "add_option": "Προσθήκη επιλογής",
  "assign": "Ανάθεση",
  "copy_field": "Αντιγραφή πεδίου",
  "delete_field": "Διαγραφή πεδίου",
  "drag_field": "Σύρετε για αλλαγή σειράς",
  "field_type": "Τύπος πεδίου",
  "remove_option": "Αφαίρεση επιλογής",
  "selection_rule": "Κανόνας επιλογής",
  "selection_count": "Αριθμός επιλογών",
  "select_at_least": "Επιλογές τουλάχιστον",
  "select_equals_to": "Επιλογές ίσον με",
  "select_more_than": "Επιλογές περισσότερα από",
  "who_should_make_the_submission": "Ποιός πρέπει να το υποβάλλει",
  "create_template": "Δημιουργία πρότυπου",
  "create_form_to_be_submitted": "Δημιουργία προτύπου για να υποβληθεί",
  "form_title": "Τίτλος φόρμας",
  "form_description": "Περιγραφή φόρμας",
  "form_due_date": "Προθεσμία φόρμας",
  "player_form": "Παίκτης",
  "profile": "Παίκτης",
  "profiles": "Παίκτες",
  "form_title_placeholder": "Τίτλος φόρμας",
  "form_description_placeholder": "Εισάγετε μια περιγραφή...",
  "form_due_date_placeholder": "Εισάγετε ημερομηνία",
  "question": "Ερώτηση",
  "required": "Υποχρεωτικό",
  "option": "Επιλογή",
  "long_text": "Μεγάλο κείμενο",
  "short_text": "Μικρό κείμενο",
  "number": "Αριθμός",
  "multiple_choice": "Πολλαπλή επιλογή",
  "linear_scale": "Γραμμική κλίμακα",
  "checkboxes": "Πλαίσια ελέγχου",
  "dropdown": "Αναπτυσσόμενο",
  "phone": "Τηλέφωνο",
  "yes_no": "Όχι/Ναι",
  "legal": "Νομικό",
  "file_upload": "Μεταφόρτωση αρχείου",
  "form_successfully": "Η φόρμα δημιουργήθηκε με επιτυχία",
  "no": "Όχι",
  "yes": "Ναι",
  "forms": "Φόρμες",
  "no_forms_found": "Δε βρέθηκαν φόρμες.",
  "assign_form": "Ανάθεση φόρμας",
  "no_assignments_found": "Δε βρέθηκαν αναθέσεις.",
  "assignment_was_successful": "Η ανάθεση φόρμας ήταν επιτυχής",
  "submitter": "Υποβάλλων",
  "add_form": "Προσθήκη φόρμας",
  "are_you_sure_you_want_to_delete_this_assignment": "Είστε σίγουροι ότι θέλετε να διαγράψετε αυτήν την ανάθεση?",
  "delete_assignment": "Διαγραφή ανάθεσης",
  "assignment_successfully_deleted": "Η ανάθεση διαγράφηκε με επιτυχία",
  "description": "Περιγραφή",
  "answer": "Απάντηση",
  "reject": "Μη αποδοχή",
  "approve": "Αποδοχή",
  "reject_assignment": "Μη αποδοχή ανάθεσης",
  "view_assignment": "Προβολή ανάθεσης",
  "are_you_sure_you_want_to_reject_this_assignment": "Είστε σίγουροι ότι δε θέλετε να αποδεχτείτε αυτήν την ανάθεση?",
  "newMessage": "Νέο μήνυμα",
  "please_send_message": "Αποστολή μηνύματος",
  "are_you_sure_want_to_delete_this_message": "Είστε σίγουροι ότι θέλετε να διαγράψετε αυτό το μήνυμα?",
  "delete_message": "Διαγραφή μηνύματος",
  "messageDeletedSuccessfully": "Το μήνυμα διαγράφηκε με επιτυχία",
  "messageNotDeleted": "Το μήνυμα δε διαγράφηκε",
  "createdAt": "Δημιουργήθηκε",
  "updatedAt": "Ενημερώθηκε",
  "reviewed": "Εξετάστηκαν",
  "waitingForApproval": "Περιμένουν επιβεβαίωση",
  "rejection_reason": "Λόγος μη αποδοχής",
  "back_to_submitter": "Πίσω για υποβολή",
  "select_less_than": "Επιλογές λιγότερες από",
  "none": "Κανένα",
  "dateSubmitted": "Ημερομηνία υποβολής",
  "forms_page_subtitle": "Συγκέντρωσε στοιχεία από γονείς και παίκτες ή δημιούργησε αξιολογήσεις που συμπληρώνουν οι προπονητές.",
  "rejecting_assignment_successful": "Η μη αποδοχή της ανάθεσης ήταν επιτυχής",
  "approving_assignment_successful": "Η αποδοχή της ανάθεσης ολοκληρώθηκε με επιτυχία",
  "users_successfully_added": "Οι χρήστες/ης προστέθηκε με επιτυχία",
  "view_product": "Προβολή προϊόντος",
  "view_payments": "Προβολή πληρωμών",
  "view_form": "Προβολή φόρμας",
  "view_assignments": "Προβολή υποβολών",
  "delete_form": "Διαγραφή φόρμας",
  "view_team": "Προβολή ομάδας",
  "waitingAproval": "Αναμονή αποδοχής",
  "backToSubmitter": "Πίσω στον υποβολέα",
  "if_you_are_a_parent_to_a_player_go_back_to_sign_up_as_a_parent_instead": "Αν είστε γονέας παίκτη, κάνετε εγγραφή ως γονέας",
  "add_match": "Πρόσθεσε αγώνα",
  "add_matches": "Πρόσθεσε αγώνες",
  "update_fixture": "Ενημέρωση αγωνιστικής",
  "update_fixture_match": "Ενημέρωση αγώνα",
  "home_team": "Ομάδα εντός έδρας",
  "away_team": "Ομάδα εκτός έδρας",
  "match_date": "Ημερομηνία",
  "match_time": "Ώρα",
  "match_score": "Αποτέλεσμα",
  "match_status": "Κατάσταση",
  "match_venue": "Γήπεδο",
  "competition_format": "Δομή διοργάνωσης",
  "update_competition": "Ενημέρωση διοργάνωσης",
  "new_competition": "Νέα διοργάνωση",
  "competition_name": "Όνομα",
  "no_name": "<Χωρίς Όνομα>",
  "season": "Σεζόν",
  "league_name": "Όνομα",
  "error_creating_league": "Πρόβλημα στη δημιουργία πρωταθλήματος",
  "league_successfully_created": "Το πρωτάθλημα δημιουργήθηκε επιτυχώς",
  "error_updating_league": "Πρόβλημα στην ενημέρωση πρωταθλήματος",
  "league_successfully_updated": "Το πρωτάθλημε ενημερώθηκε επιτυχώς",
  "error_updating_league_competition": "Πρόβλημα στην ενημέρωση πρωταθλήματος",
  "league_competition_successfully_update": "Η διοργάνωση ενημερώθηκε επιτυχώς",
  "error_updating_league_fixture_match": "Αποτυχία ενημέρωσης αγώνα",
  "league_fixture_match_successfully_update": "Ο αγώνας ενημερώθηκε επιτυχώς",
  "error_updating_league_fixture": "Πρόβλημα στην ενημέρωση αγωνιστικής",
  "league_fixture_successfully_update": "Η αγωνιστική ενημερώθηκε επιτυχώς",
  "cup_league": "Κύπελλο",
  "tournament_league": "Τουρνουά",
  "league_league": "Πρωτάθλημα",
  "fixture_name": "Όνομα αγωνιστικής",
  "region": "Περιοχή",
  "cancel_future_events": "Ακύρωση μελλοντικών δραστηριοτήτων",
  "delete_future_events": "Διαγραφή μελλοντικών δραστηριοτήτων",
  "and_for": "μέχρι",
  "successfully": "επιτυχώς",
  "deleted_succesfully": "διαγράφηκε με επιτυχία",
  "cannot_be_empty": "δεν μπορεί να είναι κενό",
  "cannot_be_in_past": "δεν μπορεί να είναι στο παρελθόν",
  "cannot_be_in_future": "δεν μπορεί να είναι στο μέλλον",
  "cannot_be_after": "δεν μπορεί να είναι μετά",
  "cannot_be_before_start_date": "δεν μπορεί να είναι πριν από την ημερομηνία έναρξης",
  "cannot_be_after_end_date": "δεν μπορεί να είναι μετά την ημερομηνία λήξης",
  "cannot_be_after_end_of_season": "δεν μπορεί να είναι μετά το τέλος της σεζόν",
  "are_you_sure_want_to_delete_this_form": "Είστε σίγουροι ότι θέλετε να διαγράψετε αυτήν την φόρμα?",
  "form_has_been_deleted_successfully": "Η φόρμα διαγράφτηκε με επιτυχία",
  "venue_location": "Τοποθεσία αγώνα",
  "saved_match_locations": "Πρόσφατες τοποθεσίες αγώνων (έως 5)",
  "sender": "Αποστολέας",
  "receiver": "Παραλήπτης",
  "add_opponent": "Προσθήκη αντιπάλου",
  "opponents_page_title": "Αντίπαλοι",
  "opponents_page_subtitle": "Διαχειριστείτε τους αντιπάλους σας",
  "allClubs": "Όλες οι ακαδημίες",
  "accept": "Αποδοχή",
  "answer_invitation": "Απάντηση σε πρόσκληση",
  "how_you_would_like_to_answer_to": "Πως θέλετε να απαντήσετε στον",
  "opponent_invitation_was_successfully_accepted": "Η πρόσκληση για αντίπαλος αποδέχτηκε με επιτυχία",
  "opponent_invitation_was_successfully_rejected": "Η πρόσκληση του αντιπάλου απορρίφθηκε με επιτυχία",
  "accepted": "Αποδέχτηκε",
  "opponents_was_successfully_invited": "Οι αντίπαλοι προσκαλέστηκαν με επιτυχία",
  "learn_how": "Οδηγίες",
  "from_you": "από εσάς",
  "denied": "Απορρίφθηκε",
  "no_opponent_attached": "Δε βρέθηκαν αντίπαλοι για την επιλεγμένη ομάδα",
  "the_field": "Το πεδίο",
  "delete_this_offer": "Να διαγραφθεί αυτή η πρόσκληση για φιλικό?",
  "decline_this_offer": "Να απορριφθεί αυτή η πρόσκληση για φιλικό?",
  "view_offer": "Προβολή πρόσκλησης",
  "counter_offer": "Αντιπρόταση",
  "accept_offer": "Αποδοχή πρόσκλησης",
  "reject_offer": "Απόρριψη πρόσκλησης",
  "delete_offer": "Διαγραφή πρόσκλησης",
  "add_field": "Προσθήκη πεδίου",
  "delete_opponent": "Διαγραφή αντιπάλου",
  "are_you_sure_you_want_to_delete_opponent": "Είστε σίγουροι ότι θέλετε να διαγράψετε τον αντίπαλο?",
  "opponent_invitation_was_successfully_deleted": "Ο αντίπαλος διαγράφτηκε με επιτυχία",
  "successfully_submitted_counteroffer": "Η αντιπρόταση στάλθηκε με επιτυχία",
  "training_capital": "ΠΡΟΠΟΝΗΣΗ",
  "match_capital": "ΑΓΩΝΑΣ",
  "event_capital": "ΕΚΔΗΛΩΣΗ",
  "team_coach": "Προπονητής",
  "choose_roster": "Επιλογή παιχτών",
  "reject_button": "Απόρριψη",
  "totals": "Σύνολα",
  "team_attendances": "Παρουσιολογία",
  "point_guard": "Πόιντ γκαρντ",
  "shooting_guard": "Σούτινγκ γκαρντ",
  "small_forward": "Σμολ φόργουορντ",
  "power_forward": "Πάουερ φόργουορντ",
  "center": "Σέντερ",
  "to": "έως",
  "no_activities_found": "Δε βρέθηκαν δραστηριότητες.",
  "no_attendances_found": "Δε βρέθηκαν παρουσιολόγια.",
  "activities_team": "Δραστηριότητες",
  "delete_notes": "Διαγραφή σημειώσεων",
  "edit_notes": "Επεξεργασία σημειώσεων",
  "are_you_sure_want_to_delete_these_notes": "Είστε σίγουροι ότι θέλετε να διαγράψετε αυτές τις σημείωσεις;",
  "notes_successfully_deleted": "Οι σημειώσεις διαγράφτηκαν με επιτυχία",
  "notes_successfully_updated": "Οι σημειώσεις ενημερώθηκαν με επιτυχία",
  "notes_successfully_created": "Οι σημειώσεις δημιουργήθηκαν με επιτυχία",
  "rsvp": "RSVP",
  "deleted_product": "Διαγραμμένο προϊόν",
  "profile_notes_placeholder": "Γράψε εδώ σημειώσεις γι' αυτόν τον αθλητή...",
  "your_account_does_not_belong_to_a_club": "Ο λογαριασμός σας δεν ανήκει σε ακαδημία. Παρακαλώ επικοινωνήστε με τον διαχειριστή της ακαδημίας σας.",
  "last_club_admin": "Τελευταίος Διαχειριστής Ακαδημίας",
  "last_club_admin_information_message": "είναι ο τελευταίος διαχειριστής αυτής της ακαδημίας. Παρακαλώ προσθέστε άλλον και μετά διαγράψτε αυτόν.",
  "club_admin_remove_message1": "Είστε σίγουροι ότι θέλετε να αφαιρέσετε τον χρήστη",
  "club_admin_remove_message2": "με αριθμό τηλεφώνου",
  "club_admin_remove_message3": "ως διαχειριστή ακαδημίας;",
  "club_admin_successfully_removed": "Ο διαχειριστής της ακαδημίας αφαιρέθηκε με επιτυχία",
  "club_admin_successfully_created": "Ο διαχειριστής της ακαδημίας δημιουργήθηκε με επιτυχία",
  "error_creating_club_admin": "Πρόβλημα κατά την δημιουργία διαχειριστή ακαδημίας",
  "error_creating_team_admin": "Πρόβλημα κατά την δημιουργία διαχειριστή ομάδας",
  "error_creating_coach": "Πρόβλημα κατά την δημιουργία προπονητή",
  "founded": "Ιδρύθηκε",
  "premium": "Premium",
  "isPremium": "Premium;",
  "club_name": "Όνομα",
  "roles_admin": "Διαχείριση Ρόλων",
  "roles_permissions_admin": "Σελίδα Διαχείρισης Ρόλων και Δικαιωμάτων",
  "permissions": "Δικαιώματα",
  "permissions_updated": "Τα δικαιώματα του ρόλου ενημερώθηκαν με επιτυχία.",
  "clubs_admin": "Διαχείριση Ακαδημιών",
  "clubs_admin_panel": "Πίνακας Διαχείρισης Ακαδημιών",
  "no_clubs_found": "Δε βρέθηκαν ακαδημίες.",
  "new_club": "Νέα Ακαδημία",
  "register_user": "Εγγραφή Χρήστη",
  "domain_requests_admin": "Αιτήματα Domain",
  "domain_requests_admin_panel": "Αιτήματα Domain",
  "no_domain_requests_found": "Δε βρέθηκαν αιτήματα domain.",
  "domain_request_club_column": "Ακαδημία",
  "domain_request_hostname_column": "Ζητούμενο domain",
  "domain_request_status_column": "Κατάσταση",
  "domain_request_requested_at_column": "Ημερομηνία αιτήματος",
  "register": "Εγγραφή",
  "create_user": "Χρήστη",
  "edit_club": "Επεξεργασία Ακαδημίας",
  "club_manager": "Διευθυντής Ακαδημίας",
  "add_club_admin": "Νέος Διαχειριστής Ακαδημίας",
  "attach_club_admin": "Διαχειριστή Ακαδημίας",
  "the_coach": "Ο προπονητής",
  "the_team_admin": "Ο διαχειριστής της ομάδας",
  "the_club_admin": "Ο διαχειριστής της ακαδημίας",
  "create_club": "Ακαδημίας",
  "create_a_club": "Δημιούργησε Ακαδημία",
  "billing": "Χρεώσεις",
  "billing_page_subtitle": "Διαχειριστείτε τα στοιχεία τιμολόγησης, τη συνδρομή και τις πληρωμές της ακαδημίας σας.",
  "billing_page_loading": "Φόρτωση στοιχείων τιμολόγησης και συνδρομής…",
  "billing_subtitle": "Συνδρομή και πληρωμές",
  "club": "Ακαδημία",
  "enabled": "Ενεργή",
  "disabled": "Ανενεργή",
  "trial_ends": "Λήξη δοκιμαστικής περιόδου",
  "current_period_ends": "Λήξη τρέχουσας περιόδου",
  "past_due_since": "Εκπρόθεσμη πληρωμή από",
  "start_subscription": "Έναρξη συνδρομής",
  "open_billing_portal": "Διαχείριση συνδρομής",
  "refresh": "Ανανέωση",
  "retry": "Επανάληψη",
  "billing_no_access": "Μόνο τα εξουσιοδοτημένα μέλη του προσωπικού μπορούν να δουν τα στοιχεία συνδρομής και πληρωμών.",
  "billing_rollout_paused": "Η ακαδημία σας έχει προς το παρόν πλήρη πρόσβαση. Οι συνδρομές θα είναι διαθέσιμες εδώ.",
  "billing_state_loading": "Φόρτωση στοιχείων συνδρομής…",
  "billing_state_ready_to_start": "Διατίθεται δωρεάν δοκιμή 30 ημερών, χωρίς κάρτα για την έναρξη. Προσθέστε κάρτα πριν λήξει για να διατηρήσετε την πλήρη πρόσβαση. Τυχόν ποσό οφειλής θα χρεωθεί αυτόματα μετά τη δοκιμή, εκτός αν ακυρώσετε νωρίτερα.",
  "billing_state_early_signup": "Προσθέστε τώρα την κάρτα σας για να ενεργοποιήσετε τη συνδρομή σας. Η χρέωση ξεκινά την παρακάτω ημερομηνία, χωρίς επιπλέον δοκιμαστική περίοδο.",
  "billing_starts": "Έναρξη χρέωσης",
  "billing_state_no_subscription": "Η ακαδημία σας δεν έχει ενεργή συνδρομή. Το τελικό ποσό, με τυχόν εκπτώσεις, εμφανίζεται πριν την επιβεβαίωση. Δεν διατίθεται νέα δωρεάν δοκιμή.",
  "billing_state_checkout_not_open": "Η ενεργοποίηση συνδρομής δεν είναι ακόμη διαθέσιμη. Δοκιμάστε ξανά αργότερα.",
  "billing_state_checkout_not_open_until": "Η ενεργοποίηση συνδρομής θα είναι διαθέσιμη στις {date}.",
  "billing_state_trialing": "Η δωρεάν δοκιμή σας είναι ενεργή. Έχετε πλήρη πρόσβαση έως τη λήξη της.",
  "billing_state_active": "Η συνδρομή είναι ενεργή με πλήρη πρόσβαση.",
  "billing_state_past_due_grace": "Μια πληρωμή της συνδρομής εκκρεμεί. Η ακαδημία σας εξακολουθεί προς το παρόν να έχει πλήρη πρόσβαση. Ολοκληρώστε την πληρωμή για να αποφύγετε περιορισμούς.",
  "billing_state_past_due_read_only": "Εκκρεμεί πληρωμή της συνδρομής. Μπορείτε να περιηγείστε στο Manager και να βλέπετε τα στοιχεία της ακαδημίας, αλλά οι αλλαγές στα δεδομένα της ακαδημίας έχουν περιοριστεί.",
  "billing_state_read_only": "Μπορείτε να περιηγείστε στο Manager και να βλέπετε τα στοιχεία της ακαδημίας. Οι αλλαγές στα δεδομένα της ακαδημίας έχουν περιοριστεί μέχρι να αποκατασταθεί η πλήρης πρόσβαση.",
  "billing_state_inactive": "Χρειάζεται αποκατάσταση της πλήρους πρόσβασης. Μπορείτε ακόμη να περιηγείστε στο Manager και να βλέπετε τα στοιχεία της ακαδημίας, αλλά οι αλλαγές στα δεδομένα της ακαδημίας έχουν περιοριστεί.",
  "billing_state_paused": "Η συνδρομή σας είναι σε παύση. Μπορείτε ακόμη να περιηγείστε στο Manager και να βλέπετε τα στοιχεία της ακαδημίας, αλλά οι αλλαγές στα δεδομένα της ακαδημίας έχουν περιοριστεί.",
  "billing_state_cancel_scheduled": "Η συνδρομή σας έχει προγραμματιστεί να λήξει στο τέλος της τρέχουσας περιόδου. Έχετε πλήρη πρόσβαση έως τότε.",
  "billing_access_full": "Πλήρης πρόσβαση",
  "billing_access_read_only": "Πρόσβαση μόνο για προβολή",
  "billing_access_inactive": "Η πλήρης πρόσβαση έχει διακοπεί",
  "billing_commercial_terms": "50 €/μήνα ή 500 €/έτος, με ΦΠΑ όπου εφαρμόζεται. Μπορείτε να καταχωρίσετε κωδικό προσφοράς κατά την έναρξη της συνδρομής.",
  "error_loading_billing": "Δεν μπορέσαμε να φορτώσουμε τα στοιχεία της συνδρομής σας. Κάντε ανανέωση και δοκιμάστε ξανά.",
  "error_starting_subscription": "Δεν μπορέσαμε να ανοίξουμε τη σελίδα έναρξης συνδρομής. Δοκιμάστε ξανά.",
  "error_opening_portal": "Δεν μπορέσαμε να ανοίξουμε τη διαχείριση συνδρομής. Δοκιμάστε ξανά.",
  "billing_missing_checkout_url": "Δεν μπορέσαμε να ανοίξουμε τη σελίδα έναρξης συνδρομής. Δοκιμάστε ξανά.",
  "billing_missing_portal_url": "Δεν μπορέσαμε να ανοίξουμε τη διαχείριση συνδρομής. Δοκιμάστε ξανά.",
  "billing_country_gr": "Ελλάδα",
  "billing_country_cy": "Κύπρος",
  "billing_identity_checkout_in_progress": "Η διαδικασία έναρξης συνδρομής βρίσκεται ήδη σε εξέλιξη. Ολοκληρώστε την ή δοκιμάστε ξανά σε λίγο.",
  "error_updating_billing_email": "Δεν μπορέσαμε να ενημερώσουμε το email τιμολόγησης. Δοκιμάστε ξανά.",
  "not_subscribed": "Χωρίς συνδρομή",
  "stripe_status_active": "Ενεργή",
  "stripe_status_trialing": "Δωρεάν δοκιμή",
  "stripe_status_past_due": "Εκκρεμεί πληρωμή",
  "stripe_status_canceled": "Ακυρωμένη",
  "stripe_status_unpaid": "Μη εξοφλημένη",
  "stripe_status_incomplete": "Εκκρεμεί ολοκλήρωση",
  "stripe_status_incomplete_expired": "Η έναρξη δεν ολοκληρώθηκε",
  "stripe_status_paused": "Σε παύση",
  "ROLE_ALREADY_EXISTS": "Ο ρόλος υπάρχει ήδη",
  "USER_NOT_ADMIN": "Ο χρήστης δεν είναι διαχειριστής",
  "USER_NOT_AUTHORISED": "Ο χρήστης δεν έχει πρόσβαση",
  "CLUB_ALREADY_EXISTS": "Η ακαδημία υπάρχει ήδη",
  "CLUB_NOT_FOUND": "Η ακαδημία δε βρέθηκε",
  "CLUB_INVALID_INPUT": "Λάθος εισαγωγή στοιχείων ακαδημίας",
  "CLUB_CREATION_FAILED": "Αποτυχία δημιουργίας ακαδημίας",
  "CLUB_UPDATE_FAILED": "Αποτυχία ενημέρωσης ακαδημίας",
  "CLUB_DELETION_FAILED": "Αποτυχία διαγραφής ακαδημίας",
  "USER_NOT_CLUB_ADMIN": "Ο χρήστης δεν είναι διαχειριστής ακαδημίας",
  "USER_THE_ONLY_CLUB_ADMIN": "Ο χρήστης δεν μπορεί να διαγραφεί, επειδή είναι ο μόνος διαχειριστής της ακαδημίας. Παρακαλώ προσθέστε κάποιον άλλο χρήστη ως διαχειριστή ακαδημίας και μετά προχωρήστε σε διαγραφή",
  "LEAGUE_ALREADY_EXISTS": "Το πρωτάθλημα υπάρχει ήδη",
  "LEAGUE_NOT_FOUND": "Το πρωτάθλημα δε βρέθηκε",
  "LEAGUE_INVALID_INPUT": "Λάθος εισαγωγή στοιχείων πρωταθλήματος",
  "LEAGUE_CREATION_FAILED": "Αποτυχία δημιουργίας πρωταθλήματος",
  "LEAGUE_UPDATE_FAILED": "Αποτυχία ενημέρωσης πρωταθλήματος",
  "LEAGUE_DELETION_FAILED": "Αποτυχία διαγραφής πρωταθλήματος",
  "COMPETITION_ALREADY_EXISTS": "Η διοργάνωση υπάρχει ήδη",
  "COMPETITION_NOT_FOUND": "Η διοργάνωση δε βρέθηκε",
  "COMPETITION_INVALID_INPUT": "Λάθος εισαγωγή στοιχείων διοργάνωσης",
  "COMPETITION_CREATION_FAILED": "Αποτυχία δημιουργίας διοργάνωσης",
  "COMPETITION_UPDATE_FAILED": "Αποτυχία ενημέρωσης διοργάνωσης",
  "COMPETITION_DELETION_FAILED": "Αποτυχία διαγραφής διοργάνωσης",
  "FIXTURE_ALREADY_EXISTS": "Η αγωνιστική υπάρχει ήδη",
  "FIXTURE_NOT_FOUND": "Η αγωνιστική δε βρέθηκε",
  "FIXTURE_INVALID_INPUT": "Λάθος εισαγωγή στοιχείων",
  "FIXTURE_CREATION_FAILED": "Αποτυχία δημιουργίας αγωνιστικής",
  "FIXTURE_UPDATE_FAILED": "Αποτυχία ενημέρωσης αγωνιστικής",
  "FIXTURE_DELETION_FAILED": "Αποτυχία διαγραφής αγωνιστικής",
  "FIXTURE_MATCH_ALREADY_EXISTS": "Ο αγώνας υπάρχει ήδη",
  "FIXTURE_MATCH_NOT_FOUND": "Ο αγώνας δε βρέθηκε",
  "FIXTURE_MATCH_INVALID_INPUT": "Λάθος εισαγωγή στοιχείων αγώνα",
  "FIXTURE_MATCH_CREATION_FAILED": "Αποτυχία δημιουργίας αγώνα",
  "USER_ALREADY_EXISTS": "Υπάρχει ήδη χρήστης με αυτά τα στοιχεία.",
  "USER_NOT_FOUND": "Ο χρήστης δε βρέθηκε",
  "USER_INVALID_INPUT": "Λάθος εισαγωγή στοιχείων χρήστη",
  "USER_CREATION_FAILED": "Αποτυχία δημιουργίας χρήστη",
  "USER_UPDATE_FAILED": "Αποτυχία ενημέρωσης χρήστη",
  "USER_DELETION_FAILED": "Αποτυχία διαγραφής χρήστη",
  "TEAM_ALREADY_EXISTS": "Η ομάδα υπάρχει ήδη",
  "TEAM_NOT_FOUND": "Η ομάδα δε βρέθηκε",
  "TEAM_INVALID_INPUT": "Λάθος εισαγωγή στοιχείων ομάδας",
  "TEAM_CREATION_FAILED": "Αποτυχία δημιουργίας ομάδας",
  "TEAM_UPDATE_FAILED": "Αποτυχία ενημέρωσης ομάδας",
  "TEAM_DELETION_FAILED": "Αποτυχία διαγραφής ομάδας",
  "TEAM_LOCKED": "Η ομάδα είναι κλειδωμένη. δεν μπορείτε να κάνετε join.",
  "CANNOT_REMOVE_LAST_ADMIN": "Δεν μπορείτε να αφαιρέσετε τον τελευταίο διαχειριστή",
  "USER_NOT_TEAM_ADMIN": "Ο χρήστης δεν είναι διαχειριστής ομάδας",
  "USER_ALREADY_TEAM_ADMIN": "Ο χρήστης είναι ήδη διαχειριστής ομάδας",
  "USER_NOT_COACH": "Ο χρήστης δεν είναι προπονητής",
  "USER_ALREADY_COACH": "Ο χρήστης είναι ήδη προπονητής",
  "MATCH_ALREADY_EXISTS": "Ο αγώνας υπάρχει ήδη",
  "MATCH_NOT_FOUND": "Ο αγώνας δε βρέθηκε",
  "MATCH_INVALID_INPUT": "Λάθος εισαγωγή στοιχείων αγώνα",
  "MATCH_CREATION_FAILED": "Αποτυχία δημιουργίας αγώνα",
  "MATCH_UPDATE_FAILED": "Αποτυχία ενημέρωσης αγώνα",
  "MATCH_DELETION_FAILED": "Αποτυχία διαγραφής αγώνα",
  "MATCH_REPORT_ALREADY_EXISTS": "Ο αγώνας έχει καταχωρημένο σκορ ή αναφορά αγώνα",
  "MATCH_REPORT_NOT_FOUND": "Η αναφορά αγώνα δε βρέθηκε",
  "MATCH_REPORT_INVALID_INPUT": "Λάθος εισαγωγή στοιχείων αναφοράς αγώνα",
  "MATCH_REPORT_CREATION_FAILED": "Αποτυχία δημιουργίας αναφοράς αγώνα",
  "MATCH_REPORT_UPDATE_FAILED": "Αποτυχία ενημέρωσης αναφοράς αγώνα",
  "MATCH_REPORT_DELETION_FAILED": "Αποτυχία διαγραφής αναφοράς αγώνα",
  "INVITATION_ALREADY_EXISTS": "Η πρόσκληση υπάρχει ήδη",
  "INVITATION_NOT_FOUND": "Η πρόσκληση δε βρέθηκε",
  "INVITATION_INVALID_INPUT": "Λάθος εισαγωγή στοιχείων πρόσκλησης",
  "INVITATION_CREATION_FAILED": "Αποτυχία δημιουργίας πρόσκλησης",
  "INVITATION_UPDATE_FAILED": "Αποτυχία ενημέρωσης πρόσκλησης",
  "INVITATION_DELETION_FAILED": "Αποτυχία διαγραφής πρόσκλησης",
  "FRIENDLY_INVITATION_ALREADY_EXISTS": "Η πρόσκληση φιλικού αγώνα υπάρχει ήδη",
  "FRIENDLY_INVITATION_NOT_FOUND": "Η πρόσκληση φιλικού αγώνα δε βρέθηκε",
  "FRIENDLY_INVITATION_INVALID_INPUT": "Λάθος εισαγωγή στοιχείων πρόσκλησης φιλικού αγώνα",
  "FRIENDLY_INVITATION_CREATION_FAILED": "Αποτυχία δημιουργίας πρόσκλησης φιλικού αγώνα",
  "FRIENDLY_INVITATION_UPDATE_FAILED": "Αποτυχία ενημέρωσης πρόσκλησης φιλικού αγώνα",
  "FRIENDLY_INVITATION_DELETION_FAILED": "Αποτυχία διαγραφής πρόσκλησης φιλικού αγώνα",
  "FRIENDLY_MATCH_ALREADY_EXISTS": "Ο φιλικός αγώνας υπάρχει ήδη",
  "FRIENDLY_MATCH_NOT_FOUND": "Ο φιλικός αγώνας δε βρέθηκε",
  "FRIENDLY_MATCH_INVALID_INPUT": "Λάθος εισαγωγή στοιχείων φιλικού αγώνα",
  "FRIENDLY_MATCH_CREATION_FAILED": "Αποτυχία δημιουργίας φιλικού αγώνα",
  "FRIENDLY_MATCH_UPDATE_FAILED": "Αποτυχία ενημέρωσης φιλικού αγώνα",
  "FRIENDLY_MATCH_DELETION_FAILED": "Αποτυχία διαγραφής φιλικού αγώνα",
  "FRIENDLY_MATCH_RESULT_ALREADY_EXISTS": "Το αποτέλεσμα υπάρχει ήδη",
  "FRIENDLY_MATCH_RESULT_NOT_FOUND": "Το αποτέλεσμα δε βρέθηκε",
  "FRIENDLY_MATCH_RESULT_INVALID_INPUT": "Λάθος εισαγωγή στοιχείων αποτελέσματος",
  "FRIENDLY_MATCH_RESULT_CREATION_FAILED": "Αποτυχία δημιουργίας αποτελέσματος",
  "FRIENDLY_MATCH_RESULT_UPDATE_FAILED": "Αποτυχία ενημέρωσης αποτελέσματος",
  "FRIENDLY_MATCH_RESULT_DELETION_FAILED": "Αποτυχία διαγραφής αποτελέσματος",
  "FRIENDLY_MATCH_REQUEST_ALREADY_EXISTS": "Η αίτηση για φιλικό αγώνα υπάρχει ήδη",
  "FRIENDLY_MATCH_REQUEST_NOT_FOUND": "Η αίτηση για φιλικό αγώνα δε βρέθηκε",
  "FRIENDLY_MATCH_REQUEST_INVALID_INPUT": "Λάθος εισαγωγή στοιχείων αίτησης για φιλικό αγώνα",
  "FRIENDLY_MATCH_REQUEST_CREATION_FAILED": "Αποτυχία δημιουργίας αίτησης για φιλικό αγώνα",
  "FRIENDLY_MATCH_REQUEST_UPDATE_FAILED": "Αποτυχία ενημέρωσης αίτησης για φιλικό αγώνα",
  "FRIENDLY_MATCH_REQUEST_DELETION_FAILED": "Αποτυχία διαγραφής αίτησης για φιλικό αγώνα",
  "EVENT_ALREADY_EXISTS": "Η εκδήλωση υπάρχει ήδη",
  "EVENT_NOT_FOUND": "Η εκδήλωση δε βρέθηκε",
  "EVENT_INVALID_INPUT": "Λάθος εισαγωγή στοιχείων εκδήλωσης",
  "EVENT_CREATION_FAILED": "Αποτυχία δημιουργίας εκδήλωσης",
  "EVENT_UPDATE_FAILED": "Αποτυχία ενημέρωσης εκδήλωσης",
  "EVENT_DELETION_FAILED": "Αποτυχία διαγραφής εκδήλωσης",
  "INVALID_RSVP_DEADLINE": "Η προθεσμία απάντησης δεν είναι έγκυρη",
  "RSVP_TOO_EARLY": "Το RSVP είναι πολύ νωρίς",
  "RSVP_AFTER_ARRIVAL": "Το RSVP δεν μπορεί να είναι μετά την ώρα συνάντησης",
  "INVALID_ARRIVAL_DATE": "Μη έγκυρη ημερομηνία άφιξης",
  "ARRIVAL_TOO_EARLY": "Η ώρα συνάντησης είναι πολύ νωρίς",
  "INVALID_FROM_DATE": "Μη έγκυρη ημερομηνία έναρξης",
  "FROM_DATE_IN_PAST": "Η ημερομηνία έναρξης δεν μπορεί να είναι στο παρελθόν",
  "INVALID_TO_DATE": "Μη έγκυρη ημερομηνία λήξης",
  "INVALID_OFFSET": "Μη έγκυρη τιμή στην ώρα άφιξης ή συνάντησης",
  "FILE_NOT_FOUND": "Το αρχείο δε βρέθηκε",
  "FILE_TICKET_NOT_FOUND": "Το κοινοποιημένο αρχείο δε βρέθηκε",
  "FILE_UPLOAD_UNAUTHORISED": "Ο χρήστης δεν έχει πρόσβαση να ανεβάσει αρχείο",
  "FILE_DELETE_UNAUTHORISED": "Ο χρήστης δεν έχει πρόσβαση να διαγράψει αρχείο",
  "INVALID_FILE_TYPE": "Μη έγκυρος τύπος αρχείου",
  "FILE_UPLOAD_FAILED": "Η μεταφόρτωση (upload) του αρχείου απέτυχε",
  "FILE_METADATA_DELETE_FAILED": "Η διαγραφή των metadata του αρχείου απέτυχε",
  "FILE_DELETE_FAILED": "Η διαγραφή του αρχείου απέτυχε",
  "FORM_ALREADY_EXISTS": "Η φόρμα υπάρχει ήδη",
  "FORM_NOT_FOUND": "Η φόρμα δε βρέθηκε",
  "FORM_INVALID_INPUT": "Λάθος εισαγωγή στοιχείων φόρμας",
  "FORM_CREATION_FAILED": "Αποτυχία δημιουργίας φόρμας",
  "FORM_UPDATE_FAILED": "Αποτυχία ενημέρωσης φόρμας",
  "FORM_DELETION_FAILED": "Αποτυχία διαγραφής φόρμας",
  "FORM_CONTAINS_ASSIGNMENTS": "Η φόρμα περιέχει αναθέσεις",
  "ANSWER_FORM_ALREADY_EXISTS": "Η απάντηση υπάρχει ήδη",
  "ANSWER_FORM_NOT_FOUND": "Η απάντηση δε βρέθηκε",
  "ANSWER_FORM_INVALID_INPUT": "Λάθος εισαγωγή στοιχείων απάντησης",
  "ANSWER_FORM_NOT_AUTHORISED": "Ο χρήστης δεν έχει πρόσβαση να απαντήσει στη φόρμα",
  "ANSWER_FORM_CREATION_FAILED": "Αποτυχία δημιουργίας απάντησης",
  "ANSWER_FORM_UPDATE_FAILED": "Αποτυχία ενημέρωσης απάντησης",
  "ANSWER_FORM_DELETION_FAILED": "Αποτυχία διαγραφής απάντησης",
  "POST_ALREADY_EXISTS": "Η ανακοίνωση υπάρχει ήδη",
  "POST_NOT_FOUND": "Η ανακοίνωση δε βρέθηκε",
  "POST_INVALID_INPUT": "Λάθος εισαγωγή στοιχείων ανακοίνωσης",
  "POST_CREATION_FAILED": "Αποτυχία δημιουργίας ανακοίνωσης",
  "POST_CREATION_UNAUTHORISED": "Ο χρήστης δεν έχει πρόσβαση να δημιουργήσει ανακοίνωση",
  "POST_UPDATE_FAILED": "Αποτυχία ενημέρωσης ανακοίνωσης",
  "POST_DELETION_FAILED": "Αποτυχία διαγραφής ανακοίνωσης",
  "POST_DELETE_UNAUTHORISED": "Ο χρήστης δεν έχει πρόσβαση να διαγράψει την ανακοίνωση",
  "POST_EDIT_UNAUTHORISED": "Ο χρήστης δεν έχει πρόσβαση να επεξεργαστεί την ανακοίνωση",
  "REACTION_ALREADY_EXISTS": "Η αντίδραση υπάρχει ήδη",
  "REACTION_NOT_FOUND": "Η αντίδραση δε βρέθηκε",
  "REACTION_INVALID_INPUT": "Λάθος εισαγωγή στοιχείων αντίδρασης",
  "REACTION_CREATION_FAILED": "Αποτυχία δημιουργίας αντίδρασης",
  "REACTION_UPDATE_FAILED": "Αποτυχία ενημέρωσης αντίδρασης",
  "REACTION_DELETION_FAILED": "Αποτυχία διαγραφής αντίδρασης",
  "INVALID_REACTION_TYPE": "Λάθος τύπος αντίδρασης",
  "PROFILE_ALREADY_EXISTS": "Ο παίκτης υπάρχει ήδη",
  "PROFILE_NOT_FOUND": "Ο παίκτης δε βρέθηκε",
  "PROFILE_INVALID_INPUT": "Λάθος εισαγωγή στοιχείων παίκτη",
  "PROFILE_CREATION_FAILED": "Αποτυχία δημιουργίας παίκτη",
  "PROFILE_UPDATE_FAILED": "Αποτυχία ενημέρωσης παίκτη",
  "PROFILE_DELETION_FAILED": "Αποτυχία διαγραφής παίκτη",
  "PROFILE_CREATE_UNAUTHORISED": "Ο χρήστης δεν έχει πρόσβαση να δημιουργήσει παίκτη",
  "PROFILE_DELETE_UNAUTHORISED": "Ο χρήστης δεν έχει πρόσβαση να διαγράψει παίκτη",
  "PROFILE_PARENT_NOT_FOUND": "Ο γονέας δε βρέθηκε",
  "PROFILE_PARENT_DELETE_UNAUTHORISED": "Ο χρήστης δεν έχει πρόσβαση να διαγράψει τον γονέα",
  "PROFILE_USER_NOT_FOUND": "Ο χρήστης δε βρέθηκε",
  "PROFILE_ALREADY_CLAIMED": "Ο παίκτης έχει ήδη αποδεχθεί την πρόσκληση",
  "PROFILE_ONLY_ONE_TEAM": "Ο παίκτης πρέπει να ανήκει σε τουλάχιστον μία ομάδα",
  "RSVP_ALREADY_EXISTS": "Το RSVP υπάρχει ήδη",
  "RSVP_NOT_FOUND": "Το RSVP δε βρέθηκε",
  "RSVP_INVALID_INPUT": "Λάθος εισαγωγή στοιχείων RSVP",
  "RSVP_CREATION_FAILED": "Αποτυχία δημιουργίας RSVP",
  "RSVP_UPDATE_FAILED": "Αποτυχία ενημέρωσης RSVP",
  "RSVP_DELETION_FAILED": "Αποτυχία διαγραφής RSVP",
  "RSVP_CANNOT_ANSWER_DEADLINE_PASSED": "Το RSVP δεν μπορεί να απαντηθεί λόγω λήξης της προθεσμίας",
  "RSVP_CANNOT_ANSWER_EVENT_CANCELLED": "Το RSVP δεν μπορεί να απαντηθεί λόγω ακύρωσης της δραστηριότητας.",
  "RSVP_FULL": "Η RSVP λίστα είναι γεμάτη γι' αυτή τη δραστηριότητα.",
  "RSVP_UNAUTHORISED": "Ο χρήστης δεν έχει πρόσβαση να απαντήσει στο RSVP",
  "ORDER_ALREADY_EXISTS": "Η παραγγελία υπάρχει ήδη",
  "ORDER_NOT_FOUND": "Η παραγγελία δε βρέθηκε",
  "ORDER_INVALID_INPUT": "Λάθος εισαγωγή στοιχείων παραγγελίας",
  "ORDER_CREATION_FAILED": "Αποτυχία δημιουργίας παραγγελίας",
  "ORDER_UPDATE_FAILED": "Αποτυχία ενημέρωσης παραγγελίας",
  "ORDER_DELETION_FAILED": "Η παραγγελία δεν μπορεί να διαγραφεί επειδή περιλαμβάνει εξοφλημένη πληρωμή.",
  "ORDER_UNAUTHORISED": "Ο χρήστης δεν έχει πρόσβαση να διαγράψει παραγγελία",
  "PAYMENT_ALREADY_EXISTS": "Η πληρωμή υπάρχει ήδη",
  "PAYMENT_NOT_FOUND": "Η πληρωμή δε βρέθηκε",
  "PAYMENT_INVALID_INPUT": "Λάθος εισαγωγή στοιχείων πληρωμής",
  "PAYMENT_CREATION_FAILED": "Αποτυχία δημιουργίας πληρωμής",
  "PAYMENT_UPDATE_FAILED": "Αποτυχία ενημέρωσης πληρωμής",
  "PAYMENT_DELETION_FAILED": "Αποτυχία διαγραφής πληρωμής",
  "PAYMENT_UNAUTHORISED": "Ο χρήστης δεν έχει πρόσβαση να δημιουργήσει ή να ακυρώσει πληρωμή",
  "PAYMENT_ALREADY_CANCELLED": "Η πληρωμή έχει ήδη ακυρωθεί",
  "PAYMENT_ALREADY_PAID": "Η πληρωμή έχει ήδη πραγματοποιηθεί",
  "PAYMENT_REMINDER_IN_PROGRESS": "Αυτή τη στιγμή αποστέλλεται υπενθύμιση πληρωμής. Δοκιμάστε ξανά σε λίγο.",
  "PRODUCT_ALREADY_EXISTS": "Το προϊόν υπάρχει ήδη",
  "PRODUCT_NOT_FOUND": "Το προϊόν δε βρέθηκε",
  "PRODUCT_INVALID_INPUT": "Λάθος εισαγωγή στοιχείων προϊόντος",
  "PRODUCT_CREATION_FAILED": "Αποτυχία δημιουργίας προϊόντος",
  "PRODUCT_UPDATE_FAILED": "Αποτυχία ενημέρωσης προϊόντος",
  "PRODUCT_DELETION_FAILED": "Αποτυχία διαγραφής προϊόντος",
  "PRODUCT_UNAUTHORISED": "Ο χρήστης δεν έχει πρόσβαση να δημιουργήσει προϊόν",
  "login_with_email": "Σύνδεση με email",
  "login_with_phone": "Σύνδεση με τηλέφωνο",
  "get_mobile_app": "Κατέβασε την εφαρμογή αν είσαι προπονητής, παίκτης ή γονέας.",
  "download_on_app_store": "Λήψη από το App Store",
  "get_it_on_google_play": "Αποκτήστε το στο Google Play",
  "mobile_not_registered_use_email": "Η σύνδεση μέσω SMS δεν είναι διαθέσιμη για αυτόν τον αριθμό. Συνεχίστε με email.",
  "email_placeholder": "Διεύθυνση email",
  "send_magic_link": "Αποστολή συνδέσμου σύνδεσης",
  "check_email": "Εισαγάγετε το email σας και θα σας στείλουμε έναν ασφαλή σύνδεσμο σύνδεσης.",
  "email_link_sent": "Σας έχουμε στείλει έναν σύνδεσμο σύνδεσης. Παρακαλώ ελέγξτε το email σας.",
  "invalid_email": "Παρακαλώ εισαγάγετε μια έγκυρη διεύθυνση email.",
  "signing_in": "Γίνεται σύνδεση",
  "login_session_expired": "Η συνεδρία σύνδεσης έληξε. Ζητήστε νέο magic link από αυτόν τον browser.",
  "invalid_or_expired_login_link": "Ο σύνδεσμος σύνδεσης δεν είναι έγκυρος ή έχει λήξει. Ζητήστε νέο magic link.",
  "add_email": "Προσθήκη email",
  "add_email_body": "Η σύνδεση με SMS θα καταργηθεί σύντομα. Προσθέστε το email σας για να συνεχίσετε να συνδέεστε χωρίς διακοπή.",
  "save_email": "Αποθήκευση email",
  "remind_me_later": "Υπενθύμιση αργότερα",
  "email_saved_successfully": "Το email αποθηκεύτηκε με επιτυχία.",
  "email_login_remembered_helper": "Η σύνδεση με email παραμένει ενεργή ώστε ο σύνδεσμος να ανοίγει με ασφάλεια.",
  "enter_valid_email_or_mobile": "Παρακαλώ εισαγάγετε έγκυρο email ή κινητό.",
  "contact": "Επικοινωνία",
  "date_of_birth": "Ημερομηνία γέννησης",
  "male": "Άνδρας",
  "female": "Γυναίκα",
  "medical_info": "Ιατρικές πληροφορίες",
  "no_allergies_or_conditions": "Χωρίς αλλεργίες ή παθήσεις",
  "add_allergy_or_condition": "Προσθήκη αλλεργίας ή πάθησης",
  "allergy_or_condition_required": "Η αλλεργία ή πάθηση είναι υποχρεωτική",
  "address": "Διεύθυνση",
  "street": "Οδός",
  "city": "Πόλη",
  "state": "Περιφέρεια",
  "postal_code": "Ταχυδρομικός κώδικας",
  "emergency_contact": "Επαφή έκτακτης ανάγκης",
  "emergency_contact_name": "Όνομα επαφής έκτακτης ανάγκης",
  "emergency_contact_relationship": "Σχέση με τον/την παίκτη/τρια",
  "emergency_contact_phone": "Τηλέφωνο επαφής έκτακτης ανάγκης",
  "emergency_contact_email": "Email επαφής έκτακτης ανάγκης",
  "invalid_emergency_contact_email": "Πληκτρολογήστε έγκυρο email επαφής έκτακτης ανάγκης",
  "gdpr_document": "Έγγραφο GDPR/πολιτικής απορρήτου",
  "upload_gdpr_document": "Ανέβασμα εγγράφου GDPR",
  "replace_gdpr_document": "Αντικατάσταση εγγράφου GDPR",
  "view_gdpr_document": "Προβολή εγγράφου GDPR",
  "gdpr_document_uploaded": "Το έγγραφο GDPR ανέβηκε με επιτυχία",
  "gdpr_document_save_pending": "Δεν έχει αποθηκευτεί ακόμη. Επιλέξτε Αποθήκευση για να δημοσιευτεί το έγγραφο.",
  "gdpr_document_upload_failed": "Αποτυχία ανεβάσματος εγγράφου GDPR",
  "GDPR_DOCUMENT_CHANGED": "Το έγγραφο GDPR άλλαξε. Ανανεώστε τη σελίδα και διαβάστε το τρέχον έγγραφο πριν δοκιμάσετε ξανά.",
  "GDPR_UPLOAD_EXPIRED": "Η μεταφόρτωση έληξε ή ακυρώθηκε. Ανεβάστε ξανά το έγγραφο.",
  "GDPR_UPLOAD_NOT_VERIFIED": "Δεν ήταν δυνατή η επαλήθευση του εγγράφου. Η τρέχουσα πολιτική GDPR διατηρήθηκε. Δοκιμάστε ξανά.",
  "no_gdpr_document": "Δεν έχει ανέβει έγγραφο GDPR",
  "gdpr_policy": "Πολιτική απορρήτου/GDPR",
  "gdpr_policy_subtitle": "Κατάσταση συγκατάθεσης και πολιτική απορρήτου της ακαδημίας.",
  "accept_gdpr_policy": "Αποδέχομαι την πολιτική απορρήτου/GDPR της ακαδημίας",
  "gdpr_acceptance_required": "Πρέπει να αποδεχτείτε την πολιτική απορρήτου/GDPR της ακαδημίας πριν συνεχίσετε.",
  "gdpr_consent_missing": "Λείπει η συγκατάθεση GDPR",
  "gdpr_consent_accepted": "Το GDPR έχει γίνει αποδεκτό",
  "gdpr_consent_stale": "Η συγκατάθεση GDPR είναι παλιά",
  "gdpr_consent_not_required": "Δεν απαιτείται GDPR",
  "gdpr_accepted_at": "Αποδοχή στις",
  "profile_identity_documents": "Ταυτότητα και έγγραφα",
  "profile_identity_documents_subtitle": "Στοιχεία ταυτότητας, Δελτίο Αθλητή και Κάρτα Υγείας.",
  "medical_info_subtitle": "Αλλεργίες, παθήσεις και σχετικές σημειώσεις.",
  "address_subtitle": "Ταχυδρομική διεύθυνση του παίκτη.",
  "contacts_subtitle": "Συνδεδεμένος χρήστης και λογαριασμοί γονέων.",
  "profile_photo": "Φωτογραφία προφίλ",
  "clothing_size": "Μέγεθος ρουχισμού",
  "ssn_amka": "ΑΜΚΑ",
  "athlete_id": "Δελτίο Αθλητή",
  "athlete_id_number": "Αριθμός",
  "athlete_id_expiration_date": "Ημερομηνία λήξης Δελτίου Αθλητή",
  "athlete_id_document": "Έγγραφο Δελτίου Αθλητή",
  "medical_clearance": "Κάρτα Υγείας",
  "medical_clearance_start_date": "Ημερομηνία έναρξης Κάρτας Υγείας",
  "medical_clearance_expiration_date": "Ημερομηνία λήξης Κάρτας Υγείας",
  "medical_clearance_document": "Έγγραφο Κάρτας Υγείας",
  "start_date": "Ημερομηνία Έναρξης",
  "expiration_date": "Ημερομηνία Λήξης",
  "add_medical_clearance": "Προσθήκη Κάρτας Υγείας",
  "remove_medical_clearance": "Αφαίρεση Κάρτας Υγείας",
  "remove_medical_clearance_document_hint": "Αφαιρέστε πρώτα το συνημμένο έγγραφο Κάρτας Υγείας για να εκκαθαρίσετε τα στοιχεία της.",
  "clear_athlete_id": "Εκκαθάριση Δελτίου Αθλητή",
  "clear_athlete_id_document_hint": "Αφαιρέστε πρώτα το συνημμένο έγγραφο Δελτίου Αθλητή για να εκκαθαρίσετε τα στοιχεία του.",
  "delete_player": "Διαγραφή παίκτη",
  "delete_player_warning": "Η διαγραφή είναι οριστική και δεν μπορεί να αναιρεθεί.",
  "delete_player_related_data_warning": "Θα διαγραφούν οριστικά όλες οι πληρωμές του παίκτη, συμπεριλαμβανομένων των εξοφλημένων, οι παραγγελίες, οι σημειώσεις, οι αναθέσεις φορμών και οι συμμετοχές του στις δραστηριότητες των ομάδων του. Η ενέργεια δεν μπορεί να αναιρεθεί.",
  "upload_document": "Μεταφόρτωση εγγράφου",
  "view_document": "Προβολή εγγράφου",
  "delete_document": "Διαγραφή εγγράφου",
  "confirm_delete_document": "Να διαγραφεί αυτό το έγγραφο;",
  "document_deleted": "Το έγγραφο διαγράφηκε",
  "document_delete_failed": "Η διαγραφή του εγγράφου απέτυχε",
  "document_selected": "Επιλέχθηκε έγγραφο",
  "profile_document_invalid_date": "Εισαγάγετε έγκυρη ημερομηνία σε μορφή YYYY-MM-DD",
  "medical_clearance_reversed_dates": "Η ημερομηνία έναρξης δεν μπορεί να είναι μετά την ημερομηνία λήξης",
  "profile_document_empty": "Το έγγραφο δεν μπορεί να είναι κενό",
  "profile_document_tooLarge": "Το έγγραφο πρέπει να είναι έως 15 MiB",
  "profile_document_unsupported": "Χρησιμοποιήστε έγγραφο PDF ή εικόνα PNG, JPG/JPEG, GIF, SVG, WebP ή HEIC",
  "BILLING_CLUB_WRITE_RESTRICTED": "Για αυτή την αλλαγή χρειάζεται πλήρης πρόσβαση της ακαδημίας. Ελέγξτε τη συνδρομή ή επικοινωνήστε με τον υπεύθυνο συνδρομής της ακαδημίας σας.",
  "profile_document_invalid_request": "Το αίτημα για το έγγραφο δεν είναι έγκυρο. Ελέγξτε το αρχείο και τα απαιτούμενα στοιχεία του εγγράφου και δοκιμάστε ξανά.",
  "profile_document_authentication_required": "Η συνεδρία σας έληξε. Συνδεθείτε ξανά για να αλλάξετε το έγγραφο.",
  "profile_document_not_authorized": "Δεν έχετε δικαίωμα αλλαγής αυτού του εγγράφου Προφίλ.",
  "profile_document_conflict": "Το έγγραφο έχει αλλάξει ή η μεταφόρτωση δεν ισχύει πλέον. Ανανεώστε και δοκιμάστε ξανά.",
  "profile_document_service_unavailable": "Δεν ήταν δυνατή η αλλαγή του εγγράφου επειδή η υπηρεσία αποθήκευσης δεν είναι προσωρινά διαθέσιμη. Δοκιμάστε ξανά.",
  "profile_document_timeout": "Το αίτημα για το έγγραφο έληξε λόγω χρόνου. Ανανεώστε για να ελέγξετε την τρέχουσα κατάστασή του πριν δοκιμάσετε ξανά.",
  "profile_document_save_failed": "Δεν ήταν δυνατή η ολοκλήρωση των αλλαγών στα έγγραφα Προφίλ. Ανανεώστε για να ελέγξετε την τρέχουσα κατάστασή τους πριν δοκιμάσετε ξανά.",
  "profile_management_load_failed": "Δεν ήταν δυνατή η φόρτωση των δεδομένων διαχείρισης Προφίλ.",
  "profile_photo_empty": "Επιλέξτε μια μη κενή φωτογραφία Προφίλ.",
  "profile_photo_upload_requirements": "JPEG, PNG ή WebP (μέγιστο 5 MiB)",
  "profile_photo_unsupported": "Χρησιμοποιήστε φωτογραφία Προφίλ JPEG, PNG ή WebP.",
  "profile_photo_invalid_request": "Το αίτημα φωτογραφίας Προφίλ δεν ήταν έγκυρο.",
  "profile_photo_authentication_required": "Η συνεδρία σας έληξε. Συνδεθείτε ξανά για να αλλάξετε τη φωτογραφία Προφίλ.",
  "profile_photo_not_authorized": "Δεν έχετε εξουσιοδότηση να ενημερώσετε αυτή τη φωτογραφία Προφίλ.",
  "profile_photo_not_found": "Το Προφίλ δεν βρέθηκε.",
  "profile_photo_conflict": "Η φωτογραφία Προφίλ άλλαξε κατά τη μεταφόρτωση. Ανανεώστε και δοκιμάστε ξανά.",
  "profile_photo_too_large": "Η φωτογραφία Προφίλ πρέπει να είναι έως 5 MiB.",
  "profile_photo_invalid_image": "Δεν ήταν δυνατή η αποκωδικοποίηση της φωτογραφίας Προφίλ. Χρησιμοποιήστε έγκυρη εικόνα JPEG, PNG ή WebP.",
  "profile_photo_processing_failed": "Η υπηρεσία επεξεργασίας φωτογραφιών Προφίλ δεν είναι προσωρινά διαθέσιμη.",
  "profile_photo_processing_timeout": "Η επεξεργασία της φωτογραφίας Προφίλ έληξε λόγω χρόνου. Δοκιμάστε ξανά.",
  "profile_photo_upload_failed": "Δεν ήταν δυνατή η ολοκλήρωση της αλλαγής της φωτογραφίας Προφίλ. Ανανεώστε για να ελέγξετε την τρέχουσα κατάστασή της πριν δοκιμάσετε ξανά.",
  "login_mobile": "Κινητό σύνδεσης",
  "add_login_mobile": "Προσθήκη κινητού σύνδεσης",
  "contact_phone": "Τηλέφωνο επικοινωνίας",
  "add_contact_phone": "Προσθήκη τηλεφώνου επικοινωνίας",
  "edit_contact_phone": "Επεξεργασία τηλεφώνου επικοινωνίας",
  "contact_phone_helper": "Διαχωρίστε πολλούς αριθμούς με κόμμα ή νέα γραμμή. Αδειάστε το πεδίο για να αφαιρέσετε όλους τους αριθμούς επικοινωνίας.",
  "contact_phone_save_failed": "Δεν ήταν δυνατή η αποθήκευση του τηλεφώνου επικοινωνίας. Δοκιμάστε ξανά.",
  "user_photo": "Φωτογραφία λογαριασμού",
  "add_user_photo": "Προσθήκη φωτογραφίας λογαριασμού",
  "change_user_photo": "Αλλαγή φωτογραφίας λογαριασμού",
  "edit_user_photo": "Επεξεργασία φωτογραφίας λογαριασμού",
  "remove_user_photo": "Αφαίρεση φωτογραφίας",
  "retry_user_photo_refresh": "Επανάληψη ανανέωσης",
  "user_photo_upload_requirements": "JPEG, PNG ή WebP (μέγιστο 5 MiB)",
  "user_photo_empty": "Επιλέξτε μια μη κενή φωτογραφία λογαριασμού.",
  "user_photo_unsupported": "Χρησιμοποιήστε φωτογραφία λογαριασμού JPEG, PNG ή WebP.",
  "user_photo_invalid_request": "Το αίτημα φωτογραφίας λογαριασμού δεν ήταν έγκυρο.",
  "user_photo_authentication_required": "Η συνεδρία σας έληξε. Συνδεθείτε ξανά για να αλλάξετε τη φωτογραφία λογαριασμού.",
  "user_photo_not_authorized": "Δεν έχετε εξουσιοδότηση να αλλάξετε αυτή τη φωτογραφία λογαριασμού.",
  "user_photo_not_found": "Ο λογαριασμός χρήστη δεν βρέθηκε.",
  "user_photo_conflict": "Η φωτογραφία λογαριασμού άλλαξε κατά τη μεταφόρτωση. Ανανεώστε και δοκιμάστε ξανά.",
  "user_photo_too_large": "Η φωτογραφία λογαριασμού πρέπει να είναι έως 5 MiB.",
  "user_photo_invalid_image": "Δεν ήταν δυνατή η αποκωδικοποίηση της φωτογραφίας λογαριασμού. Χρησιμοποιήστε έγκυρη εικόνα JPEG, PNG ή WebP.",
  "user_photo_processing_failed": "Η υπηρεσία επεξεργασίας φωτογραφιών λογαριασμού δεν είναι προσωρινά διαθέσιμη.",
  "user_photo_processing_timeout": "Η επεξεργασία της φωτογραφίας λογαριασμού έληξε λόγω χρόνου. Δοκιμάστε ξανά.",
  "user_photo_upload_failed": "Δεν ήταν δυνατή η μεταφόρτωση της φωτογραφίας λογαριασμού. Δοκιμάστε ξανά.",
  "user_photo_remove_failed": "Δεν ήταν δυνατή η αφαίρεση της φωτογραφίας λογαριασμού. Δοκιμάστε ξανά.",
  "user_photo_refresh_failed": "Η φωτογραφία άλλαξε, αλλά ο λογαριασμός δεν ανανεώθηκε. Επαναλάβετε την ανανέωση χωρίς νέα μεταφόρτωση.",
  "user_photo_impersonation_forbidden": "Οι αλλαγές φωτογραφίας λογαριασμού δεν είναι διαθέσιμες κατά την πλαστοπροσωπία.",
  "account_settings": "Ρυθμίσεις λογαριασμού",
  "club_settings": "Ρυθμίσεις ακαδημίας",
  "account_settings_subtitle": "Διαχειριστείτε τα προσωπικά στοιχεία σύνδεσης και επικοινωνίας σας.",
  "account_settings_impersonation_notice": "Οι ρυθμίσεις λογαριασμού δεν μπορούν να αλλάξουν κατά την πλαστοπροσωπία χρήστη.",
  "account_menu": "Μενού λογαριασμού",
  "open_account_menu": "Άνοιγμα μενού λογαριασμού",
  "appearance": "Εμφάνιση",
  "dark_mode": "Σκοτεινή λειτουργία",
  "sign_in_and_contact": "Σύνδεση και επικοινωνία",
  "login_email": "Email σύνδεσης",
  "change_email": "Αλλαγή email",
  "add_email_title": "Προσθήκη email",
  "current_email": "Τρέχον email",
  "new_email": "Νέο email",
  "email_change_verification_notice": "Το email σας δεν θα αλλάξει μέχρι να ανοίξετε τον σύνδεσμο επιβεβαίωσης και να ολοκληρώσετε τη διαδικασία.",
  "email_change_verification_sent": "Ο σύνδεσμος επιβεβαίωσης στάλθηκε. Ελέγξτε το email σας για να ολοκληρώσετε την αλλαγή.",
  "email_add_verification_sent": "Ο σύνδεσμος επιβεβαίωσης στάλθηκε. Ελέγξτε το email σας για να ολοκληρώσετε την προσθήκη.",
  "email_change_impersonation_forbidden": "Οι αλλαγές email δεν είναι διαθέσιμες κατά την πλαστοπροσωπία χρήστη.",
  "email_change_already_in_use": "Αυτό το email χρησιμοποιείται ήδη από άλλον λογαριασμό.",
  "email_change_auth_required": "Η συνεδρία σας άλλαξε. Συνδεθείτε ξανά και δοκιμάστε πάλι.",
  "email_change_send_failed": "Δεν ήταν δυνατή η αποστολή του συνδέσμου επιβεβαίωσης. Δοκιμάστε ξανά.",
  "send_verification_link": "Αποστολή συνδέσμου επιβεβαίωσης",
  "change_mobile_number": "Αλλαγή αριθμού κινητού",
  "add_mobile_number": "Προσθήκη αριθμού κινητού",
  "current_mobile": "Τρέχον κινητό",
  "mobile_number": "Αριθμός κινητού",
  "mobile_international_format_helper": "Χρησιμοποιήστε διεθνή μορφή, για παράδειγμα +306900000000",
  "sms_verification_code": "Κωδικός επιβεβαίωσης SMS",
  "send_sms_code": "Αποστολή κωδικού SMS",
  "verify_code": "Επιβεβαίωση κωδικού",
  "send_new_code": "Αποστολή νέου κωδικού",
  "retry_synchronization": "Επανάληψη συγχρονισμού",
  "email_change_sync_retry_notice": "Το email σας επιβεβαιώθηκε. Δοκιμάστε ξανά για να ολοκληρωθεί η ενημέρωση της σύνδεσής σας. Δεν χρειάζεται νέος κωδικός.",
  "mobile_change_verified": "Ο αριθμός κινητού σας επιβεβαιώθηκε και ενημερώθηκε.",
  "mobile_change_impersonation_forbidden": "Οι αλλαγές αριθμού κινητού δεν είναι διαθέσιμες κατά την πλαστοπροσωπία χρήστη.",
  "mobile_change_sync_retry_notice": "Η επιβεβαίωση μέσω SMS ολοκληρώθηκε, αλλά πρέπει να επαναληφθεί ο συγχρονισμός. Δεν απαιτείται νέο SMS.",
  "mobile_change_invalid": "Εισαγάγετε έναν έγκυρο αριθμό κινητού σε διεθνή μορφή.",
  "mobile_change_invalid_code": "Ο κωδικός επιβεβαίωσης SMS δεν είναι έγκυρος.",
  "mobile_change_code_expired": "Η συνεδρία επιβεβαίωσης SMS έληξε. Ζητήστε νέο κωδικό.",
  "mobile_change_too_many_attempts": "Πάρα πολλές προσπάθειες. Περιμένετε πριν δοκιμάσετε ξανά.",
  "mobile_change_already_in_use": "Αυτός ο αριθμός κινητού χρησιμοποιείται ήδη από άλλον λογαριασμό.",
  "mobile_change_recent_login_required": "Για λόγους ασφαλείας, συνδεθείτε ξανά πριν αλλάξετε τον αριθμό κινητού σας.",
  "mobile_change_account_changed": "Ο συνδεδεμένος λογαριασμός άλλαξε. Συνδεθείτε ξανά και ξεκινήστε από την αρχή.",
  "mobile_change_sync_pending": "Ο αριθμός επιβεβαιώθηκε, αλλά ο συγχρονισμός του λογαριασμού εκκρεμεί. Επαναλάβετε τον συγχρονισμό.",
  "mobile_change_failed": "Δεν ήταν δυνατή η αλλαγή του αριθμού κινητού. Δοκιμάστε ξανά.",
  "team_drawer_description": "Διαχειριστείτε τα στοιχεία, την εικόνα εξωφύλλου και την πρόσβαση της ομάδας.",
  "team_details_title": "Στοιχεία ομάδας",
  "team_details_description": "Ορίστε το όνομα και την ηλικιακή κατηγορία της ομάδας.",
  "team_cover_title": "Εικόνα εξωφύλλου",
  "team_cover_description": "Ανεβάστε την εικόνα εξωφύλλου που εμφανίζεται στη σελίδα και στις κάρτες της ομάδας στην εφαρμογή κινητού.",
  "team_access_title": "Πρόσβαση ομάδας",
  "team_access_description": "Ελέγξτε την πρόσβαση και δημιουργήστε νέο κωδικό ομάδας.",
  "files_drawer_description": "Επιλέξτε ποιοι έχουν πρόσβαση στα αρχεία και μεταφορτώστε νέα έγγραφα.",
  "file_access_title": "Πρόσβαση στα αρχεία",
  "file_access_description": "Επιλέξτε τις ομάδες και τους παίκτες που έχουν πρόσβαση σε αυτά τα αρχεία.",
  "file_upload_title": "Αρχεία προς μεταφόρτωση",
  "file_upload_description": "Προσθέστε τα αρχεία που θέλετε να κοινοποιήσετε.",
  "notes_drawer_description": "Προσθέστε ή ενημερώστε τις σημειώσεις για αυτόν τον παίκτη.",
  "order_summary_description": "Ελέγξτε τα στοιχεία της παραγγελίας και το ιστορικό πληρωμών.",
  "register_user_description": "Προσθέστε έναν χρήστη και ορίστε την πρόσβασή του σε ακαδημία ή ομάδα.",
  "user_identity_title": "Στοιχεία χρήστη",
  "user_identity_description": "Καταχωρίστε το όνομα και τα στοιχεία επικοινωνίας του χρήστη.",
  "user_access_title": "Ρόλος και πρόσβαση",
  "user_access_description": "Επιλέξτε τον ρόλο, την ακαδημία και την ομάδα του χρήστη.",
  "add_club_admin_description": "Βρείτε έναν υπάρχοντα χρήστη και προσθέστε τον ως διαχειριστή ακαδημίας.",
  "find_user_title": "Εύρεση χρήστη",
  "find_user_description": "Αναζητήστε με διεύθυνση email ή αριθμό κινητού.",
  "edit_club_description": "Ενημερώστε τα στοιχεία, την εμφάνιση, τα έγγραφα και τους διαχειριστές της ακαδημίας.",
  "create_club_description": "Προσθέστε τα στοιχεία και την εμφάνιση της ακαδημίας.",
  "club_details_title": "Στοιχεία ακαδημίας",
  "club_details_description": "Ορίστε το όνομα, τη συντομογραφία, το έτος ίδρυσης, τη χώρα και το άθλημα.",
  "club_branding_title": "Εμφάνιση ακαδημίας",
  "club_branding_description": "Επιλέξτε το χρώμα της ακαδημίας και μεταφορτώστε το λογότυπό της.",
  "gdpr_document_description": "Κατεβάστε το τρέχον έγγραφο ή επιλέξτε ένα νέο και πατήστε Αποθήκευση για να δημοσιευτεί.",
  "club_admins_description": "Δείτε τους διαχειριστές της ακαδημίας και τα στοιχεία επικοινωνίας τους.",
  "no_club_admins": "Δεν βρέθηκαν διαχειριστές ακαδημίας.",
  "club_admins_load_failed": "Δεν ήταν δυνατή η φόρτωση των διαχειριστών. Δοκιμάστε ξανά.",
  "assignment_drawer_description": "Ελέγξτε τα στοιχεία της ανάθεσης και τις υποβληθείσες απαντήσεις.",
  "assignment_details_title": "Στοιχεία ανάθεσης",
  "assignment_details_description": "Ελέγξτε τις πληροφορίες της φόρμας και την ημερομηνία λήξης.",
  "assignment_responses_title": "Υποβληθείσες απαντήσεις",
  "assignment_responses_description": "Ελέγξτε τις απαντήσεις του παίκτη σε κάθε ερώτηση.",
  "not_added": "Δεν έχει προστεθεί",
  "super_admin": "Υπερδιαχειριστής",
  "staff_page_subtitle": "Πρόσθεσε προπονητές και διαχειριστές στην ακαδημία και όρισε τις ομάδες και τους ρόλους τους.",
  "staff_page_summary": "{{count}} μέλη προσωπικού στην ακαδημία",
  "staff_search": "Αναζήτηση ονόματος, email ή κινητού",
  "staff_all_roles": "Όλοι οι ρόλοι",
  "staff_admin": "Διαχειριστής",
  "staff_add_team": "Προσθήκη ομάδας…",
  "staff_activity": "Δραστηριότητα",
  "staff_recently_active": "Πρόσφατα ενεργός",
  "staff_last_active": "Τελευταία δραστηριότητα",
  "staff_never_connected": "Δεν έχει συνδεθεί ποτέ",
  "staff_activity_unknown": "Δεν έχει καταγραφεί δραστηριότητα",
  "staff_activity_hint": "Καταγράφηκε δραστηριότητα τα τελευταία 5 λεπτά.",
  "staff_no_results": "Δεν βρέθηκε προσωπικό με αυτά τα φίλτρα.",
  "staff_load_failed": "Δεν ήταν δυνατή η φόρτωση του προσωπικού. Δοκιμάστε ξανά.",
  "staff_no_access": "Πρέπει να είστε διαχειριστής της επιλεγμένης ακαδημίας για να διαχειριστείτε το προσωπικό της.",
  "staff_remove": "Αφαίρεση προσωπικού",
  "staff_remove_confirmation": "Να αφαιρεθεί κάθε πρόσβαση προσωπικού για τον χρήστη {{name}} στην ακαδημία {{club}};",
  "staff_remove_scope": "Αφαιρούνται οι αναθέσεις διαχειριστή ακαδημίας, διαχειριστή ομάδας και προπονητή σε αυτή την ακαδημία. Διατηρούνται ο λογαριασμός, η πρόσβαση παίκτη ή γονέα και η πρόσβαση σε άλλες ακαδημίες.",
  "staff_remove_failed": "Δεν ήταν δυνατή η αφαίρεση της πρόσβασης προσωπικού. Δοκιμάστε ξανά.",
  "staff_removed": "Η πρόσβαση προσωπικού αφαιρέθηκε.",
  "staff_join_instructions": "Το προσωπικό μπορεί να συνδεθεί με αυτό το email ή κινητό. Η πρόσβαση που του ανατέθηκε θα είναι διαθέσιμη αυτόματα.",
  "STAFF_INVALID_INPUT": "Ελέγξτε τα στοιχεία προσωπικού, τον ρόλο και τις επιλεγμένες ομάδες και δοκιμάστε ξανά.",
  "STAFF_CANNOT_REMOVE_SELF": "Ένας άλλος διαχειριστής ακαδημίας πρέπει να αφαιρέσει την πρόσβασή σας ως προσωπικό.",
  "STAFF_CANNOT_REMOVE_LAST_CLUB_ADMIN": "Προσθέστε άλλον διαχειριστή ακαδημίας πριν αφαιρέσετε τον τελευταίο.",
  "AUTH_IDENTITY_CONFLICT": "Αυτά τα στοιχεία επικοινωνίας δεν αντιστοιχούν σε έναν υπάρχοντα λογαριασμό. Χρησιμοποιήστε το τρέχον email ή κινητό του λογαριασμού.",
  "PAYER_OWNER_MUST_RELINQUISH": "Ορίστε νέο κάτοχο της συνδρομής πριν αφαιρέσετε αυτόν τον διαχειριστή.",
  "PAYER_CLUB_ADMIN_HANDOFF_REQUIRED": "Αναθέστε τη διαχείριση της συνδρομής σε άλλον διαχειριστή πριν αφαιρέσετε αυτόν τον διαχειριστή.",
  "PAYER_ACCESS_STATE_NOT_PERSISTED": "Δεν μπορέσαμε να επιβεβαιώσουμε τα δικαιώματα διαχείρισης της συνδρομής. Δοκιμάστε ξανά.",
  "profile_no_linked_account": "Δεν υπάρχει συνδεδεμένος λογαριασμός",
  "profile_activity_load_failed": "Δεν ήταν δυνατή η φόρτωση της δραστηριότητας λογαριασμού. Δοκιμάστε ξανά.",
  "deployment_update_title": "Διαθέσιμη νέα έκδοση",
  "deployment_update_description": "Αποθηκεύστε τις αλλαγές σας και μετά ανανεώστε τη σελίδα για να ενημερωθεί το Manager.",
  "deployment_update_refresh": "Ανανέωση",
  "billing_trial_reminder_days": "Η δωρεάν δοκιμή σας λήγει σε {days} ημέρες",
  "billing_trial_reminder_last_day": "Η δωρεάν δοκιμή σας λήγει μέσα στις επόμενες 24 ώρες",
  "billing_trial_reminder_add_card": "Προσθέστε κάρτα για να συνεχίσετε να χρησιμοποιείτε όλες τις λειτουργίες μετά τη δοκιμή. Τυχόν ποσό οφειλής θα χρεωθεί αυτόματα όταν λήξει, εκτός αν ακυρώσετε νωρίτερα.",
  "billing_trial_reminder_contact_admin": "Ζητήστε από τον υπεύθυνο συνδρομής της ακαδημίας σας να προσθέσει κάρτα πριν λήξει η δοκιμή, για να διατηρήσετε την πλήρη πρόσβαση.",
  "billing_add_card": "Προσθήκη κάρτας",
  "billing_state_full_without_subscription": "Η ακαδημία σας έχει προς το παρόν πλήρη πρόσβαση χωρίς συνδρομή. Ξεκινήστε συνδρομή για να συνεχίσετε να χρησιμοποιείτε όλες τις λειτουργίες μετά τη λήξη της δωρεάν πρόσβασης.",
  "billing_state_trialing_without_card": "Η δωρεάν δοκιμή σας είναι ενεργή με πλήρη πρόσβαση. Δεν έχει προστεθεί ακόμη κάρτα. Χρειάζεται κάρτα πριν λήξει η δοκιμή για να συνεχίσετε να χρησιμοποιείτε όλες τις λειτουργίες.",
  "billing_state_trialing_with_card": "Η δωρεάν δοκιμή σας είναι ενεργή με πλήρη πρόσβαση και έχει αποθηκευτεί τρόπος πληρωμής. Τυχόν ποσό οφειλής θα χρεωθεί αυτόματα όταν λήξει η δοκιμή, εκτός αν ακυρώσετε νωρίτερα.",
  "billing_state_past_due_inactive": "Η πλήρης πρόσβαση έχει διακοπεί επειδή εκκρεμεί πληρωμή της συνδρομής. Μπορείτε ακόμη να περιηγείστε στο Manager και να βλέπετε τα στοιχεία της ακαδημίας, αλλά οι αλλαγές στα δεδομένα της ακαδημίας έχουν περιοριστεί.",
  "billing_state_trial_ended": "Η δωρεάν δοκιμή σας έληξε. Μπορείτε ακόμη να περιηγείστε στο Manager και να βλέπετε τα στοιχεία της ακαδημίας, αλλά οι αλλαγές στα δεδομένα της ακαδημίας έχουν περιοριστεί.",
  "billing_notice_view_only": "Η ακαδημία σας έχει πρόσβαση μόνο για προβολή",
  "billing_notice_restore_access": "Επαναφορά πλήρους πρόσβασης",
  "billing_notice_payment_attention": "Εκκρεμεί πληρωμή",
  "billing_notice_cancel_scheduled": "Η συνδρομή σας πρόκειται να λήξει",
  "billing_notice_subscription": "Ενεργοποιήστε τη συνδρομή της ακαδημίας σας",
  "billing_review_subscription": "Προβολή συνδρομής",
  "billing_contact_administrator": "Επικοινωνήστε με τον υπεύθυνο συνδρομής της ακαδημίας σας για βοήθεια.",
  "billing_recovery_start_trial": "Ξεκινήστε τη διαθέσιμη δωρεάν δοκιμή 30 ημερών για να επαναφέρετε την πλήρη πρόσβαση. Δεν χρειάζεται κάρτα για την έναρξη.",
  "billing_recovery_start_subscription": "Ξεκινήστε συνδρομή για να επαναφέρετε την πλήρη πρόσβαση. Το τελικό ποσό, με τυχόν εκπτώσεις, εμφανίζεται πριν την επιβεβαίωση.",
  "billing_recovery_manage_subscription": "Ανοίξτε τη Διαχείριση συνδρομής για να δείτε το επόμενο βήμα για την επαναφορά της πλήρους πρόσβασης.",
  "billing_recovery_contact_support": "Επικοινωνήστε με την υποστήριξη του PlayerDex για την επαναφορά της πλήρους πρόσβασης.",
  "billing_state_full_needs_review": "Η ακαδημία σας έχει προς το παρόν πλήρη πρόσβαση. Ελέγξτε τη συνδρομή σας για να συνεχίσετε να χρησιμοποιείτε όλες τις λειτουργίες.",
  "billing_state_needs_review": "Ελέγξτε τα στοιχεία της συνδρομής σας ή επικοινωνήστε με την υποστήριξη του PlayerDex για βοήθεια.",
  "registration_billing_setup_failed": "Η ακαδημία σας δημιουργήθηκε, αλλά η δοκιμαστική περίοδος δεν έχει ενεργοποιηθεί ακόμη. Δοκιμάστε ξανά για να ολοκληρώσετε την εγγραφή.",
  "billing_trial_without_details": "Ξεκινήστε τη δωρεάν δοκιμή 30 ημερών. Δεν χρειάζεται κάρτα, ΑΦΜ, διεύθυνση χρέωσης ή αποστολής.",
  "billing_details_on_stripe": "Συμπληρώστε το ΑΦΜ, την επωνυμία, τη διεύθυνση χρέωσης και το email στο Stripe. Επιστρέψτε στο Manager για να συνεχίσετε στη συνδρομή και να προσθέσετε κάρτα.",
  "billing_start_free_trial": "Έναρξη δωρεάν δοκιμής",
  "billing_complete_details": "Συμπλήρωση στοιχείων χρέωσης",
  "billing_continue_after_details": "Αποθήκευσα τα στοιχεία — συνέχεια",
  "billing_setup_error": "Δεν ήταν δυνατή η ολοκλήρωση αυτού του βήματος. Δοκιμάστε ξανά.",
  "billing_details_incomplete": "Συμπληρώστε το ΑΦΜ, την επωνυμία, τη διεύθυνση χρέωσης και το email στο Stripe και επιστρέψτε για να συνεχίσετε.",
  "billing_trial_not_available": "Δεν είναι διαθέσιμη νέα δωρεάν δοκιμή για αυτή την ακαδημία. Ανανεώστε τη σελίδα για να δείτε τις επιλογές συνδρομής.",
  "billing_trial_ending_soon": "Η δοκιμή σας λήγει σε λιγότερο από 31 λεπτά. Επιστρέψτε μετά τη λήξη της για να ολοκληρώσετε τη συνδρομή σας.",
  "billing_notice_trial_active": "Η δωρεάν δοκιμή σας είναι ενεργή",
  "billing_local_trial_active": "Η δωρεάν δοκιμή σας είναι ενεργή με πλήρη πρόσβαση. Προσθέστε τρόπο πληρωμής για να διατηρήσετε πλήρη πρόσβαση μετά τη λήξη της.",
  "billing_trial_reminder_complete_details": "Προσθέστε τρόπο πληρωμής για να διατηρήσετε πλήρη πρόσβαση μετά τη δοκιμή. Δεν θα χρεωθείτε πριν από τη λήξη της.",
  "billing_add_payment_method": "Προσθήκη τρόπου πληρωμής",
  "billing_opening_stripe": "Άνοιγμα επιλογών χρέωσης…",
  "billing_back_to_manager": "Επιστροφή στο Manager",
  "billing_return_other_club": "Επιστρέψτε στην ακαδημία για την οποία ανοίξατε τη χρέωση και δοκιμάστε ξανά.",
  "billing_resolve_payment": "Τακτοποίηση πληρωμής",
  "billing_continue_to_checkout": "Συνέχεια στην πληρωμή",
  "billing_paused_choose_plan": "Επανενεργοποίηση συνδρομής",
  "billing_paused_plan_explanation": "Επιλέξτε πλάνο και συνεχίστε στο Stripe για να προσθέσετε κάρτα και στοιχεία τιμολόγησης και να επιβεβαιώσετε την επανενεργοποίηση. Μετά την επανενεργοποίηση μπορείτε να διαχειριστείτε το πλάνο σας στο Stripe.",
  "billing_paused_plan_label": "Πλάνο συνδρομής",
  "billing_paused_monthly": "Μηνιαίο",
  "billing_paused_yearly": "Ετήσιο",
  "billing_paused_continue_stripe": "Συνέχεια στο Stripe",
  "billing_paused_state_changed": "Η συνδρομή σας έχει αλλάξει. Ανοίξτε ξανά τη Χρέωση για να δείτε τις διαθέσιμες επιλογές.",
  "billing_paused_plan_locked": "Έχει ήδη επιλεγεί πλάνο. Ανοίξτε ξανά τη Χρέωση για να συνεχίσετε με αυτό το πλάνο.",
  "billing_paused_setup_in_progress": "Η διαδικασία συνδρομής βρίσκεται ήδη σε εξέλιξη. Δοκιμάστε ξανά.",
  "billing_paused_details_required": "Για την επανενεργοποίηση χρειάζονται πλήρη στοιχεία τιμολόγησης: επωνυμία, email, διεύθυνση και ΑΦΜ. Επικοινωνήστε με την υποστήριξη αν χρειάζεστε βοήθεια για την ενημέρωσή τους.",
  "billing_paused_contact_support": "Δεν ήταν δυνατή η συνέχιση της διαδικασίας συνδρομής. Επικοινωνήστε με την υποστήριξη.",
  "website": "Ιστοσελίδα",
  "preview_website": "Προεπισκόπηση Ιστοσελίδας",
  "preview_website_no_slug": "Η προεπισκόπηση ιστοσελίδας δεν έχει ρυθμιστεί ακόμα για αυτή την ακαδημία.",
  "website_page_title": "Ιστοσελίδα",
  "website_page_subtitle": "Διαχειριστείτε και δείτε προεπισκόπηση της δημόσιας ιστοσελίδας της ακαδημίας σας.",
  "website_page_no_slug_notice": "Η διεύθυνση ιστοσελίδας της ακαδημίας σας δεν έχει ρυθμιστεί ακόμα. Επικοινωνήστε με το PlayerDex για να σας ανατεθεί μία.",
  "website_page_tab_general": "Γενικά",
  "website_page_tab_appearance": "Εμφάνιση",
  "website_page_tab_sections": "Ενότητες",
  "website_page_tab_teams": "Ομάδες",
  "website_page_tab_privacy": "Απόρρητο",
  "website_page_tab_branding": "Ταυτότητα",
  "website_page_general_section": "Γενικά",
  "website_page_slug": "Διεύθυνση ιστοσελίδας",
  "website_page_address_placeholder": "onoma-sillogou",
  "website_page_address_checking": "Έλεγχος διαθεσιμότητας…",
  "website_page_address_available": "Διαθέσιμο",
  "website_page_address_invalid_format": "Χρησιμοποιήστε 3-40 πεζά γράμματα, αριθμούς ή παύλες (όχι στην αρχή ή στο τέλος).",
  "website_page_address_reserved": "Αυτή η διεύθυνση είναι δεσμευμένη και δεν μπορεί να χρησιμοποιηθεί.",
  "website_page_address_taken": "Αυτή η διεύθυνση χρησιμοποιείται ήδη.",
  "website_page_address_check_error": "Ο έλεγχος διαθεσιμότητας απέτυχε. Δοκιμάστε ξανά.",
  "website_page_address_future_notice": "Η μελλοντική διεύθυνση ιστοσελίδας της ακαδημίας σας:",
  "website_page_custom_domain_title": "Προσαρμοσμένο domain",
  "website_page_custom_domain_desc": "Χρησιμοποιήστε το δικό σας domain (π.χ. sillogos.gr) αντί για τη δωρεάν διεύθυνση playerdex.app.",
  "website_page_custom_domain_connect_button": "Σύνδεση domain",
  "website_page_custom_domain_upgrade_notice": "Τα προσαρμοσμένα domain είναι διαθέσιμα σε πληρωμένα πακέτα.",
  "website_page_custom_domain_upgrade_button": "Αναβάθμιση",
  "website_page_custom_domain_choose_connect": "Θα το συνδέσω μόνος/η μου",
  "website_page_custom_domain_choose_assisted": "Ζητήστε από το PlayerDex να το ρυθμίσει",
  "website_page_custom_domain_hostname_placeholder": "sillogos.gr",
  "website_page_custom_domain_hostname_invalid": "Εισάγετε ένα έγκυρο domain, π.χ. sillogos.gr.",
  "website_page_custom_domain_wizard_back": "Πίσω",
  "website_page_custom_domain_wizard_continue": "Συνέχεια",
  "website_page_custom_domain_wizard_disclaimer": "Αυτό δεν είναι ακόμα πλήρως αυτόματο — η ομάδα μας ολοκληρώνει τη ρύθμιση χειροκίνητα μόλις συνεχίσετε.",
  "website_page_custom_domain_wizard_instructions_title": "Προσθέστε αυτή την εγγραφή DNS στον καταχωρητή του domain σας:",
  "website_page_custom_domain_wizard_record_type": "Τύπος",
  "website_page_custom_domain_wizard_record_host": "Όνομα",
  "website_page_custom_domain_wizard_record_value": "Τιμή",
  "website_page_custom_domain_wizard_record_value_pending": "Επιβεβαιώνεται μετά τη συνέχεια",
  "website_page_custom_domain_wizard_apex_note": "Αν το domain σας δεν έχει \"www\", θα πρέπει να ανακατευθύνει στην έκδοση με www.",
  "website_page_custom_domain_wizard_confirm": "Πρόσθεσα αυτή την εγγραφή",
  "website_page_custom_domain_assisted_submit": "Αποστολή αιτήματος",
  "website_page_custom_domain_status_requested": "Ζητήθηκε",
  "website_page_custom_domain_status_pending_dns": "Αναμονή DNS",
  "website_page_custom_domain_status_verifying": "Επαλήθευση",
  "website_page_custom_domain_status_active": "Ενεργό",
  "website_page_custom_domain_status_failed": "Απέτυχε",
  "website_page_custom_domain_status_expired": "Έληξε",
  "website_page_custom_domain_check_status": "Έλεγχος κατάστασης",
  "website_page_custom_domain_cancel": "Ακύρωση αιτήματος",
  "website_page_custom_domain_added_success": "Το αίτημα στάλθηκε.",
  "website_page_custom_domain_error": "Κάτι πήγε στραβά. Δοκιμάστε ξανά.",
  "website_page_appearance_section": "Εμφάνιση",
  "website_page_appearance_color_label": "Χρώμα έμφασης",
  "website_page_appearance_color_desc": "Επιλέξτε το χρώμα που χρησιμοποιείται στη δημόσια ιστοσελίδα της ακαδημίας σας.",
  "website_page_sections_section": "Ενότητες σελίδας",
  "website_page_sections_section_desc": "Επιλέξτε τι μπορούν να δουν οι επισκέπτες στη δημόσια ιστοσελίδα της ακαδημίας σας.",
  "website_page_toggle_staff_label": "Προπονητές & προσωπικό",
  "website_page_toggle_staff_desc": "Εμφάνιση του προπονητικού προσωπικού στην καρτέλα Ρόστερ.",
  "website_page_toggle_roster_label": "Ρόστερ παικτών",
  "website_page_toggle_roster_desc": "Εμφάνιση των παικτών της ομάδας σας στην καρτέλα Ρόστερ.",
  "website_page_toggle_events_label": "Αγώνες & αποτελέσματα",
  "website_page_toggle_events_desc": "Εμφάνιση προσεχών αγώνων και αποτελεσμάτων στην καρτέλα Αγώνες.",
  "website_page_toggle_photos_label": "Φωτογραφίες",
  "website_page_toggle_photos_desc": "Εμφάνιση φωτογραφιών αγώνων και εκδηλώσεων στην καρτέλα Φωτογραφίες.",
  "website_page_toggle_attendance_label": "Κατάταξη συμμετοχής",
  "website_page_toggle_attendance_desc": "Εμφάνιση της κατάταξης συμμετοχής στην καρτέλα Συμμετοχή.",
  "website_page_toggle_posts_label": "Νέα & ανακοινώσεις",
  "website_page_toggle_posts_desc": "Εμφάνιση των νέων της ακαδημίας σας στην καρτέλα Νέα.",
  "website_page_settings_load_error": "Δεν ήταν δυνατή η φόρτωση των ρυθμίσεων της ιστοσελίδας. Ανανεώστε τη σελίδα.",
  "website_page_settings_saved": "Οι ρυθμίσεις ιστοσελίδας αποθηκεύτηκαν.",
  "website_page_settings_save_error": "Δεν ήταν δυνατή η αποθήκευση των ρυθμίσεων. Δοκιμάστε ξανά.",
  "website_page_live_toggle_label": "Η ιστοσελίδα είναι ενεργή",
  "website_page_live_toggle_desc_on": "Οι επισκέπτες μπορούν να δουν τη δημόσια ιστοσελίδα σας.",
  "website_page_live_toggle_desc_off": "Οι επισκέπτες θα δουν μια σελίδα \"σύντομα κοντά σας\" αντί για την ιστοσελίδα σας.",
  "website_page_live_off_alert": "Η δημόσια ιστοσελίδα σας είναι απενεργοποιημένη. Οι επισκέπτες θα βλέπουν μια σελίδα \"σύντομα κοντά σας\" μέχρι να την ενεργοποιήσετε ξανά.",
  "website_page_privacy_section": "Απόρρητο",
  "website_page_privacy_section_desc": "Ελέγξτε πώς εμφανίζονται τα ονόματα και οι φωτογραφίες παικτών και προπονητών στη δημόσια ιστοσελίδα σας.",
  "website_page_name_display_label": "Εμφάνιση ονόματος",
  "website_page_name_display_full": "Πλήρες όνομα",
  "website_page_name_display_initial": "Όνομα + αρχικό επιθέτου",
  "website_page_name_display_first": "Μόνο όνομα",
  "website_page_toggle_player_photos_label": "Φωτογραφίες παικτών & προπονητών",
  "website_page_toggle_player_photos_desc": "Εμφάνιση πραγματικών φωτογραφιών στη δημόσια ιστοσελίδα. Απενεργοποιήστε για εμφάνιση μόνο αρχικών.",
  "website_page_branding_section": "Περιεχόμενο & ταυτότητα",
  "website_page_branding_section_desc": "Προσθέστε επιπλέον στοιχεία στη δημόσια ιστοσελίδα της ακαδημίας σας.",
  "website_page_about_label": "Σχετικά με την ακαδημία σας",
  "website_page_about_placeholder": "Πείτε στους επισκέπτες λίγα λόγια για την ακαδημία σας...",
  "website_page_toggle_contact_label": "Στοιχεία επικοινωνίας",
  "website_page_toggle_contact_desc": "Εμφάνιση τηλεφώνου, email και ιστοσελίδας της ακαδημίας σας στη δημόσια σελίδα.",
  "website_page_toggle_contact_phone_label": "Τηλέφωνο",
  "website_page_toggle_contact_email_label": "Email",
  "website_page_toggle_contact_website_label": "Ιστοσελίδα",
  "website_page_toggle_contact_address_label": "Διεύθυνση",
  "website_page_toggle_contact_detail_desc": "Εμφανίζεται στη δημόσια σελίδα όταν τα στοιχεία επικοινωνίας είναι ενεργά.",
  "website_page_social_https_error": "Οι σύνδεσμοι κοινωνικών δικτύων πρέπει να ξεκινούν με https://",
  "website_page_social_label": "Σύνδεσμοι κοινωνικών δικτύων",
  "website_page_social_instagram": "Instagram",
  "website_page_social_facebook": "Facebook",
  "website_page_social_x": "X (Twitter)",
  "website_page_social_youtube": "YouTube",
  "website_page_teams_search_placeholder": "Αναζήτηση ομάδων",
  "website_page_teams_filter_all": "Όλες οι ομάδες",
  "website_page_teams_filter_on": "Στην ιστοσελίδα",
  "website_page_teams_filter_hidden": "Κρυμμένες",
  "website_page_teams_age_group": "Ηλικιακή ομάδα",
  "website_page_teams_summary": "ομάδες στην ιστοσελίδα",
  "website_page_teams_selected": "επιλεγμένες",
  "website_page_teams_show": "Εμφάνιση στην ιστοσελίδα",
  "website_page_teams_hide": "Απόκρυψη από την ιστοσελίδα",
  "website_page_teams_clear_selection": "Εκκαθάριση επιλογής",
  "website_page_teams_col_team": "Ομάδα",
  "website_page_teams_col_age_group": "Ηλικιακή ομάδα",
  "website_page_teams_col_website": "Ιστοσελίδα",
  "website_page_teams_no_matches": "Καμία ομάδα δεν ταιριάζει με την αναζήτηση ή τα φίλτρα σας.",
  "website_page_teams_select_all": "Επιλογή όλων των ομάδων που εμφανίζονται",
  "website_page_teams_select_team": "Επιλογή ομάδας",
  "website_page_teams_section_desc": "Επιλέξτε ποιες ομάδες θα έχουν σελίδα στη δημόσια ιστοσελίδα της ακαδημίας σας.",
  "website_page_teams_empty": "Η ακαδημία σας δεν έχει ακόμα ομάδες.",
  "website_page_teams_load_error": "Δεν ήταν δυνατή η φόρτωση των ομάδων σας. Δοκιμάστε ξανά.",
  "activity_section_details": "Στοιχεία δραστηριότητας",
  "activity_section_timing": "Ημερομηνία & ώρα",
  "activity_section_location": "Τοποθεσία",
  "activity_section_attendance": "Ρυθμίσεις συμμετοχής",
  "activity_section_notes": "Σημειώσεις & συνημμένα",
  "activity_selected_count": "{selected} από {total} επιλεγμένοι",
  "activity_search_players": "Αναζήτηση παικτών",
  "activity_select_all": "Επιλογή όλων",
  "activity_clear_selection": "Καθαρισμός",
  "activity_show_selected": "Μόνο επιλεγμένοι",
  "activity_no_search_results": "Δεν βρέθηκαν παίκτες για την αναζήτησή σου.",
  "activity_no_participants": "Δεν υπάρχουν παίκτες στις επιλεγμένες ομάδες.",
  "activity_ends": "Λήξη",
  "activity_arrive": "Προσέλευση",
  "activity_location_selected": "Η τοποθεσία επιλέχθηκε",
  "activity_location_hint": "Αναζήτησε διεύθυνση ή επίλεξε σημείο στον χάρτη.",
  "activity_show_map": "Εμφάνιση χάρτη",
  "activity_hide_map": "Απόκρυψη χάρτη",
  "activity_details_load_error": "Δεν ήταν δυνατή η φόρτωση των στοιχείων της δραστηριότητας.",
  "activity_details_retry": "Δοκίμασε ξανά",
  "activity_details_cancelled": "Η δραστηριότητα έχει ακυρωθεί.",
  "activity_details_attendance": "Παρουσίες",
  "activity_details_rsvp": "Απαντήσεις συμμετοχής",
  "activity_details_filter": "Φίλτρο συμμετεχόντων ανά κατάσταση",
  "activity_details_show_all": "Εμφάνιση όλων των συμμετεχόντων",
  "activity_details_remind": "Υπενθύμιση σε όσους δεν απάντησαν",
  "activity_details_loading": "Φόρτωση…",
  "activity_details_no_results": "Δεν βρέθηκαν συμμετέχοντες με αυτή την αναζήτηση ή το φίλτρο.",
  "activity_details_no_participants": "Δεν υπάρχουν ακόμη συμμετέχοντες.",
  "activity_search_participants": "Αναζήτηση συμμετεχόντων",
  "activity_details_going_plural": "Θα πάνε",
  "activity_details_not_going_plural": "Δε θα πάνε",
  "activity_details_unanswered_plural": "Δεν απάντησαν",
  "activity_details_attended_singular": "Ήρθε",
  "activity_details_not_attended_singular": "Δεν ήρθε",
  "billing_tax_identity_title": "Στοιχεία φορολογικού μητρώου",
  "billing_tax_identity_explanation": "Συμπληρώστε τα στοιχεία του φορέα που θα αναγράφεται στο τιμολόγιο. Στη συνέχεια θα μεταφερθείτε στο Stripe για τα υπόλοιπα στοιχεία χρέωσης.",
  "billing_tax_country": "Χώρα τιμολόγησης",
  "billing_tax_country_gr": "Ελλάδα",
  "billing_tax_country_cy": "Κύπρος",
  "billing_tax_afm": "ΑΦΜ",
  "billing_tax_afm_hint": "9 ψηφία.",
  "billing_tax_tic": "Αριθμός φορολογικού μητρώου (TIC)",
  "billing_tax_tic_hint": "8 ψηφία και ένα λατινικό γράμμα. Υποχρεωτικό, ακόμη και χωρίς εγγραφή ΦΠΑ.",
  "billing_tax_vat_optional": "Αριθμός VAT (προαιρετικό)",
  "billing_tax_vat_hint": "Συμπληρώστε μόνο αν υπάρχει εγγραφή ΦΠΑ στην Κύπρο. Το TIC δεν αποτελεί επιβεβαίωση VAT.",
  "billing_tax_identity_invalid": "Ελέγξτε τη μορφή του ΑΦΜ/TIC και του προαιρετικού VAT.",
  "billing_tax_identity_locked": "Υπάρχει ήδη ανοικτή διαδικασία Checkout. Ολοκληρώστε την ή επικοινωνήστε με την υποστήριξη.",
  "billing_tax_identity_save_error": "Δεν αποθηκεύτηκαν τα φορολογικά στοιχεία. Δοκιμάστε ξανά.",
  "billing_tax_saving": "Αποθήκευση…",
  "billing_tax_continue": "Συνέχεια στο Stripe",
  "combobox_clear": "Καθαρισμός",
  "combobox_open": "Εμφάνιση επιλογών",
  "players_import_button": "Εισαγωγή",
  "players_import_title": "Εισαγωγή παικτών",
  "players_import_description": "Προσθέστε πολλούς παίκτες μαζί από αρχείο ή πληκτρολογώντας τους.",
  "players_import_mode_auto_title": "Ανέβασμα αρχείου",
  "players_import_mode_auto_description": "Εισαγωγή από αρχείο Excel (.xlsx, .xls), .ods ή .csv.",
  "players_import_mode_manual_title": "Πληκτρολόγηση",
  "players_import_mode_manual_description": "Συμπληρώστε έναν πίνακα με έναν παίκτη ανά γραμμή.",
  "players_import_step_file": "Αρχείο",
  "players_import_step_columns": "Στήλες",
  "players_import_step_players": "Παίκτες",
  "players_import_step_preview": "Προεπισκόπηση",
  "players_import_step_result": "Αποτέλεσμα",
  "players_import_title_file": "Εισαγωγή αρχείου παικτών",
  "players_import_title_columns": "Αντιστοίχιση στηλών αρχείου",
  "players_import_title_manual": "Προσθήκη παικτών",
  "players_import_title_preview": "Έλεγχος παικτών",
  "players_import_title_result": "Αποτέλεσμα εισαγωγής",
  "players_import_required_info": "Υποχρεωτικά στοιχεία:",
  "players_import_optional_info": "Προαιρετικά στοιχεία:",
  "players_import_drop_title": "Σύρετε και αφήστε το αρχείο σας εδώ",
  "players_import_drop_or": "ή",
  "players_import_browse": "επιλέξτε αρχείο",
  "players_import_drop_hint": "Ανεβάστε αρχείο .xlsx, .xls, .ods ή .csv (έως 5 MB)",
  "players_import_remove_file": "Αφαίρεση αρχείου",
  "players_import_file_too_large": "Το αρχείο είναι μεγαλύτερο από 5 MB.",
  "players_import_file_invalid_type": "Ανεβάστε αρχείο .xlsx, .xls, .ods ή .csv.",
  "players_import_file_empty": "Το αρχείο δεν έχει γραμμές.",
  "players_import_file_unreadable": "Δεν ήταν δυνατή η ανάγνωση του αρχείου. Ελέγξτε ότι είναι έγκυρο υπολογιστικό φύλλο.",
  "players_import_template_title": "Χρειάζεστε ένα πρότυπο;",
  "players_import_template_description": "Κατεβάστε το πρότυπό μας με τις στήλες που διαβάζουμε.",
  "players_import_template_download": "Λήψη",
  "players_import_columns_intro": "Επιλέξτε ποια στήλη του αρχείου σας περιέχει κάθε στοιχείο του παίκτη.",
  "players_import_skip_header": "Παράλειψη της πρώτης γραμμής (επικεφαλίδες)",
  "players_import_first_line": "Πρώτη γραμμή:",
  "players_import_playerdex_field": "Πεδίο Playerdex",
  "players_import_file_column": "Στήλη αρχείου",
  "players_import_column": "Στήλη",
  "players_import_select_column": "Επιλέξτε στήλη",
  "players_import_no_column": "Χωρίς εισαγωγή",
  "players_import_required": "Υποχρεωτικό",
  "players_import_optional": "Προαιρετικό",
  "players_import_field_last_name": "Επώνυμο",
  "players_import_field_last_name_example": "π.χ. Παπαδόπουλος",
  "players_import_field_first_name": "Όνομα",
  "players_import_field_first_name_example": "π.χ. Νίκος, Μαρία",
  "players_import_field_email": "Email",
  "players_import_field_email_example": "π.χ. goneas@email.com",
  "players_import_field_phone": "Τηλέφωνο",
  "players_import_field_phone_example": "π.χ. 6912345678",
  "players_import_field_birth_date": "Ημερομηνία γέννησης",
  "players_import_field_birth_date_example": "π.χ. 07/12/2014 ή 2014",
  "players_import_field_address": "Διεύθυνση",
  "players_import_field_address_example": "π.χ. Ερμού 12, Αθήνα",
  "players_import_field_team": "Ομάδα",
  "players_import_field_team_example": "Πρέπει να ταιριάζει με όνομα ομάδας, π.χ. Κ12",
  "players_import_field_gender": "Φύλο",
  "players_import_field_gender_example": "π.χ. Α / Θ",
  "players_import_field_ssn": "ΑΜΚΑ",
  "players_import_field_ssn_example": "π.χ. 07121401234",
  "players_import_field_clothing_size": "Μέγεθος ρουχισμού",
  "players_import_field_clothing_size_example": "π.χ. 12 ή M",
  "players_import_manual_intro": "Προσθέστε έναν παίκτη ανά γραμμή. Οι κενές γραμμές αγνοούνται.",
  "players_import_add_row": "Προσθήκη γραμμής",
  "players_import_remove_row": "Αφαίρεση γραμμής",
  "players_import_preview_summary": "{{ready}} έτοιμοι για εισαγωγή · {{invalid}} θέλουν διόρθωση",
  "players_import_preview_invalid_hint": "Μπορείτε να διορθώσετε κάθε κελί εδώ. Οι γραμμές που έχουν ακόμη σφάλματα θα παραλειφθούν.",
  "players_import_assign_missing_team": "{{count}} χωρίς ομάδα:",
  "players_import_assign_missing_team_label": "Ανάθεση ομάδας σε όλους τους παίκτες χωρίς ομάδα",
  "players_import_select_team": "Επιλέξτε ομάδα",
  "players_import_column_player": "Παίκτης",
  "players_import_column_status": "Κατάσταση",
  "players_import_status_ready": "Έτοιμο",
  "players_import_error_name": "Το όνομα και το επώνυμο είναι υποχρεωτικά.",
  "players_import_error_email": "Το email δεν είναι έγκυρο.",
  "players_import_error_birth_date": "Η ημερομηνία γέννησης δεν είναι έγκυρη. Χρησιμοποιήστε ΗΗ/ΜΜ/ΕΕΕΕ.",
  "players_import_error_birth_date_future": "Η ημερομηνία γέννησης είναι στο μέλλον.",
  "players_import_error_team_missing": "Επιλέξτε ομάδα.",
  "players_import_error_team_unknown": "Αυτή η ομάδα δεν υπάρχει στην ακαδημία σας. Επιλέξτε ομάδα.",
  "players_import_warning_gender": "Το φύλο δεν αναγνωρίστηκε. Θα μείνει κενό.",
  "players_import_warning_duplicate": "Ο παίκτης εμφανίζεται πάνω από μία φορά στη λίστα.",
  "players_import_submit": "Εισαγωγή {{count}} παικτών",
  "players_import_progress": "Εισαγωγή {{done}} από {{total}} παίκτες...",
  "players_import_result_created": "Εισήχθησαν {{count}} παίκτες.",
  "players_import_result_skipped": "Παραλείφθηκαν {{count}} γραμμές λόγω σφαλμάτων.",
  "players_import_result_failed": "Δεν ήταν δυνατή η εισαγωγή {{count}} παικτών.",
  "players_import_result_failed_hint": "Κατεβάστε τους, διορθώστε τους και εισάγετέ τους ξανά.",
  "players_import_error_column": "Σφάλμα",
  "players_import_download_failed": "Λήψη γραμμών με σφάλμα",
  "players_import_continue": "Συνέχεια",
  "players_import_back": "Προηγούμενο βήμα",
  "players_import_done": "Τέλος",
  "players_import_discard_title": "Διακοπή εισαγωγής;",
  "players_import_discard_description": "Οι παίκτες που προσθέσατε εδώ δεν θα αποθηκευτούν.",
  "players_import_discard_cancel": "Συνέχεια",
  "players_import_discard_confirm": "Απόρριψη",
  "players_import_birth_date_placeholder": "ΗΗ/ΜΜ/ΕΕΕΕ",
  "players_import_error_email_exists": "Υπάρχει ήδη παίκτης με αυτό το email στην ακαδημία σας.",
  "players_import_error_email_duplicate": "Αυτό το email χρησιμοποιείται ήδη σε προηγούμενη γραμμή.",
  "players_import_existing_checking": "Έλεγχος για παίκτες που υπάρχουν ήδη στην ακαδημία σας...",
  "players_import_existing_failed": "Δεν ήταν δυνατός ο έλεγχος για υπάρχοντες παίκτες. Δοκιμάστε ξανά για να συνεχίσετε.",
  "players_import_existing_found": "{{count}} παίκτες υπάρχουν ήδη στην ακαδημία σας (ίδιο email) και θα παραλειφθούν.",
  "players_import_progress_single": "Εισαγωγή {{total}} παικτών...",
  "players_import_outcome_unknown_title": "Δεν ήταν δυνατή η επιβεβαίωση της εισαγωγής",
  "players_import_outcome_unknown_description": "Κάποιοι παίκτες μπορεί να δημιουργήθηκαν. Ελέγξτε τη λίστα παικτών πριν κάνετε ξανά εισαγωγή, ώστε να μην προστεθεί κανείς δύο φορές.",
  "players_import_result_unconfirmed": "Δεν ήταν δυνατή η επιβεβαίωση για {{count}} παίκτες:",
  "EMAIL_ALREADY_EXISTS": "Υπάρχει ήδη παίκτης με αυτό το email στην ακαδημία σας",
  "INVALID_INPUT": "Κάποια από τα στοιχεία δεν είναι έγκυρα",
  "EVENT_BACKFILL_FAILED": "Δεν ήταν δυνατή η προσθήκη του παίκτη στις επερχόμενες δραστηριότητες της ομάδας",
  "BATCH_TOO_LARGE": "Πάρα πολλοί παίκτες σε μία εισαγωγή. Εισάγετε έως 500 τη φορά.",
  "PROFILE_BATCH_SCOPE_CHANGED": "Οι δραστηριότητες των ομάδων άλλαξαν κατά την εισαγωγή. Δοκιμάστε ξανά.",
  "PROFILE_BATCH_FAILED": "Η εισαγωγή απέτυχε. Δεν προστέθηκαν παίκτες. Δοκιμάστε ξανά.",
  "PROFILE_BATCH_OUTCOME_UNKNOWN": "Δεν ήταν δυνατή η επιβεβαίωση των παικτών που προστέθηκαν",
  "date_picker_open": "Επιλογή ημερομηνίας",
  "time_picker_open": "Επιλογή ώρας",
  "date_picker_previous_day": "Προηγούμενη ημέρα",
  "date_picker_next_day": "Επόμενη ημέρα",
  "date_picker_previous_month": "Προηγούμενος μήνας",
  "date_picker_next_month": "Επόμενος μήνας",
  "date_picker_previous_year": "Προηγούμενο έτος",
  "date_picker_next_year": "Επόμενο έτος",
  "date_range_start": "Ημερομηνία έναρξης",
  "date_range_end": "Ημερομηνία λήξης",
  "phone_country": "Χώρα τηλεφώνου",
  "location_fetch_error": "Δεν ήταν δυνατή η λήψη της τοποθεσίας. Δοκιμάστε ξανά.",
  "location_fetch_failed": "Δεν ήταν δυνατή η φόρτωση τοποθεσιών μετά από αρκετές προσπάθειες.",
  "billing_invoice_details_title": "Στοιχεία παραστατικού",
  "billing_invoice_status_open": "Προβολή κατάστασης παραστατικού",
  "billing_invoice_status_title": "Κατάσταση παραστατικού",
  "billing_invoice_details_open": "Συμπλήρωση στοιχείων παραστατικού",
  "billing_invoice_paid_pending": "Η πληρωμή σας ολοκληρώθηκε. Δεν χρειάζεται νέα πληρωμή.",
  "billing_invoice_details_load_error": "Δεν ήταν δυνατή η φόρτωση των στοιχείων. Δοκιμάστε ξανά ή επικοινωνήστε με τον διαχειριστή χρέωσης.",
  "billing_invoice_details_none": "Δεν εκκρεμούν στοιχεία που απαιτούν ενέργειά σας. Αν μόλις πληρώσατε, η επεξεργασία μπορεί να χρειαστεί λίγο χρόνο.",
  "billing_invoice_reference": "Αναφορά παραστατικού",
  "billing_invoice_vat_invalid": "Ο κυπριακός αριθμός ΦΠΑ δεν επαληθεύτηκε. Στο παραστατικό εφαρμόζεται ο κανονικός συντελεστής ΦΠΑ. Η πληρωμή σας παραμένει ολοκληρωμένη.",
  "billing_invoice_vies_pending": "Η επαλήθευση ΦΠΑ δεν είναι προσωρινά διαθέσιμη. Θα δοκιμάσουμε αυτόματα ξανά. Η πληρωμή σας παραμένει ολοκληρωμένη.",
  "billing_invoice_details_needed": "Συμπληρώστε τα φορολογικά στοιχεία για να προετοιμάσουμε το παραστατικό σας.",
  "billing_invoice_processing": "Δεν ζητούνται επιπλέον φορολογικά στοιχεία εδώ. Για βοήθεια με το παραστατικό ή την παράδοσή του μέσω email, επικοινωνήστε με την υποστήριξη.",
  "billing_invoice_details_explanation": "Τα στοιχεία αφορούν αυτό το πληρωμένο παραστατικό. Η χώρα προέρχεται από το Stripe. Ελέγχουμε τη μορφή του φορολογικού αριθμού και επαληθεύουμε τον κυπριακό αριθμό ΦΠΑ πριν την έκδοση.",
  "billing_invoice_details_save": "Αποθήκευση στοιχείων παραστατικού",
  "billing_invoice_details_busy": "Η επεξεργασία παραστατικών είναι σε εξέλιξη. Δοκιμάστε ξανά σε λίγο.",
  "billing_invoice_details_review": "Το παραστατικό δεν μπορεί πλέον να τροποποιηθεί εδώ. Επικοινωνήστε με την υποστήριξη.",
  "billing_invoice_future_details": "Διαχείριση μελλοντικών στοιχείων χρέωσης στο Stripe",
  "billing_continue_stripe": "Συνέχεια στο Stripe",
  "billing_annual_invoice_entry": "Πληρωμή με τραπεζική μεταφορά",
  "billing_annual_invoice_description": "Ετήσιο πρόγραμμα 500 €. Το Stripe εκδίδει το πρώτο παραστατικό με οδηγίες τραπεζικής μεταφοράς όταν η ακαδημία είναι επιλέξιμη. Οι ανανεώσεις μέσω τραπεζικής μεταφοράς δεν είναι ακόμη διαθέσιμες.",
  "billing_new_subscriptions_disabled": "Η έναρξη νέας συνδρομής δεν είναι διαθέσιμη αυτή τη στιγμή για την ακαδημία. Μπορείτε να επιστρέψετε στο Manager ή να κάνετε ανανέωση για να ελέγξετε τη διαθεσιμότητα.",
  "billing_bank_trial_conversion_unavailable": "Η τραπεζική μεταφορά δεν είναι ακόμη διαθέσιμη για την υπάρχουσα δοκιμαστική συνδρομή αυτής της ακαδημίας. Η δοκιμαστική περίοδος παραμένει ως έχει.",
  "billing_card_promotion_codes_stripe": "Εφόσον διατίθεται, εισαγάγετε τον κωδικό προσφοράς σας στο Stripe Checkout.",
  "billing_subscription_choice_description": "Επιλέξτε πώς θα πληρώσετε τη συνδρομή σας. Η πληρωμή ολοκληρώνεται με ασφάλεια στο Stripe.",
  "billing_card_subscription_entry": "Πληρωμή με κάρτα",
  "billing_card_subscription_description": "Επιλέξτε μηνιαίο ή ετήσιο πρόγραμμα στο Stripe. Οι πληρωμές και οι ανανεώσεις με κάρτα διαχειρίζονται από το Stripe.",
  "billing_bank_trial_started": "Η δοκιμαστική περίοδος 30 ημερών ξεκίνησε. Δεν απαιτείται πληρωμή τώρα. Ημερομηνία λήξης:",
  "billing_bank_annual_invoice_pending": "Το πρώτο ετήσιο παραστατικό τραπεζικής μεταφοράς δεν είναι ακόμη διαθέσιμο. Δοκιμάστε ξανά αργότερα.",
  "billing_bank_setup_pending": "Η προετοιμασία της ετήσιας συνδρομής με τραπεζική μεταφορά βρίσκεται σε εξέλιξη. Πατήστε Ανανέωση για συνέχεια."
}
